webpackJsonp([1],{

/***/ "1qRW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DN8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GdIk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02796314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("oXGk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316a2a57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("kZKJ")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2d63fc6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("jsA2")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-b2d63fc6"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d48a67d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("DN8u")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-6d48a67d"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ded350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("Vtxw")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df4e0e58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("Pqpo")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea834c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("vvnJ")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cad3ed6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("GdIk")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd893e96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("UhHM")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36934d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("UxE6")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b767d08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("UrMh")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-405171cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("aKuC")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-405171cd"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd40fbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("TKcf")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa23382e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("kxw3")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3524a822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("1qRW")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Escrime XXI N⁰. 109",
  "shortTitle": "",
  "description": "",
  "width": 1532,
  "height": 1150,
  "currentLanguage": "ES",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://escrime-xxi.fie.org/109/en/"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://escrime-xxi.fie.org/109/fr/"
  }, {
    "code": "ES",
    "text": "Spanish",
    "href": "http://escrime-xxi.fie.org/109/es/"
  }],
  "basePath": "/109/es",
  "companyLogo": "1-title.png",
  "publishURL": "http://escrime-xxi.fie.org/109/es/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "mobileSwitch": true,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n\n        <img id=\"1-0\" class=\"halfScale\" style=\"top:0px;left:371px\" src=\"/109/es/static/_content/1-x.png\">\n        \n        <img id=\"1-1\" class=\"halfScale\" style=\"top:110px;left:68px\" src=\"/109/es/static/_content/1-title.png\">\n        <img id=\"1-2\" class=\"halfScale\" style=\"top:276px;left:66px\" src=\"/109/es/static/_content/1-sub-1.png\">\n\n        <img id=\"1-3\" class=\"halfScale\" style=\"top:111px;left:1075px\" src=\"/109/es/static/_content/1-no.png\">\n\n        <img id=\"1-text-1\" class=\"halfScale pointer\" style=\"top:336px;left:788px\" onclick=\"Publish.goToPage(44)\" src=\"/109/es/static/_content/1-sub-2.png\">\n        <img id=\"1-text-2\" class=\"halfScale pointer\" style=\"top:547px;left:1149px\" onclick=\"Publish.goToPage(49)\" src=\"/109/es/static/_content/1-sub-3.png\">\n        <img id=\"1-text-3\" class=\"halfScale pointer\" style=\"top:786px;left:1045px\" onclick=\"Publish.goToPage(8)\" src=\"/109/es/static/_content/1-sub-4.png\">\n\n        <img id=\"1-4\" class=\"halfScale pointer\" style=\"top:989px;left:1441px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/1-arrow.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n          .fromTo(idOf(\"1-1\"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)\n          .fromTo(idOf(\"1-0\"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},\"-=0.2\")\n          .fromTo(idOf(\"1-2\"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-3\"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-text-1\"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-2\"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-3\"), 0.6, {x:-200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-4\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1})\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "N˚109 REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  JUNIOR Y CADETES CAMPEONATOS DEL MUNDO  YUKA UENO LA ESTRELLA EN ALZA GRAN PREMIO DOHA A EL CAIRO Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista",
    "mobileHtml": "\n      <img src=\"/109/es/static/_mobile/mobile-cover.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"halfScale 2-title\" style=\"top:108px;left:80px\" src=\"/109/es/static/_content/2-title.png\">\n\n      <img class=\"halfScale 2-icons\" style=\"top:862px;left:156px\" src=\"/109/es/static/_content/2-pop.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:862px;left:458px\" src=\"/109/es/static/_content/2-play.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:863px;left:829px\" src=\"/109/es/static/_content/2-social.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:863px;left:1152px\" src=\"/109/es/static/_content/2-numbers.png\">\n\n      <img class=\"halfScale pointer howto-desktop\" style=\"top:125px;left:1074px;opacity:1;\" onclick=\"switchPopHowto(true)\" src=\"/109/es/static/_content/2-btn-desktop.png\">\n      <img class=\"halfScale pointer howto-ipad\" style=\"top:125px;left:1276px;opacity:0\" onclick=\"switchPopHowto(false)\" src=\"/109/es/static/_content/2-btn-ipad.png\">\n\n      <img class=\"halfScale howto-desktop\" style=\"top:256px;left:84px;\" src=\"/109/es/static/_content/2-desktop.png\">\n      <img class=\"halfScale howto-ipad\" style=\"top:250px;left:69px;display:none;\" src=\"/109/es/static/_content/2-ipad.png\">\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax()\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .staggerFromTo(cOf(\"2-icons\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, \"-=0.2\")\n        }\n\n        function switchPopHowto(bool){\n          if(bool){\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-ipad\")[0].style.opacity = 0;\n              cOf(\"howto-ipad\")[1].style.display = \"none\";\n            }});\n            cOf(\"howto-desktop\")[0].style.opacity = 1;\n            cOf(\"howto-desktop\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:1});\n          }else{\n            cOf(\"howto-ipad\")[0].style.opacity = 1;\n            cOf(\"howto-ipad\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:1});\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-desktop\")[0].style.opacity = 0;\n              cOf(\"howto-desktop\")[1].style.display = \"none\";\n            }});\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "INSTRUC CIONES DE USO  Haga clic para cambiar la vista  INSTRUCCIONES DE USO  IPAD  ESCRITORIO  Escrime XXI  La revista de esgrima utiliza la última tecnología digital. Presentamos algunas características de uso para disfrutar de la publicación.  C ONOZCA A LOS ATLE TAS  EXPLORAR Utilice las flechas del teclado para desplazarse horizontalmente por la revista  Navegación  Para ver la revista, utilice las flechas del teclado para desplazarse a la izquierda y a la derecha por toda la publicación.  YUKA UENO  EXPLORADOR DE INTERNET Para obtener los mejores resultados, recomendamos el uso de Safari o Google Chrome.  EXPLORAR  r… Zonas interactivas en el interio  1 2 3 ELEMENTOS EMERGENTES  BOTÓN DE REPRODUCCIÓN  REDES SOCIALES  NÚMEROS  Pulse para mostrar u ocultar retazos de información.  En esta revista encontrará vídeos fantásticos. Pulse este botón para disfrutar de ellos.  Pulse los iconos de las redes sociales que encontrará por toda la revista.  Pulse los botones para mostrar más contenidos apasionantes.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:25px;right:40px;width:280px; height:30px;\">\n          <a href=\"https://www.tissotwatches.com/es-es/homepage\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.tissotwatches.com\" target=\"_blank\">\n        <img src=\"/109/es/static/_mobile/3.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n\n        <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <div class=\"addContentLink\" style=\"top: 191px; left:80px;width:145px; height: 35px;\">\n          <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top: 75px; right:623px;width:55px; height: 55px;\">\n          <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top:130px; right:623px;width:55px; height: 55px;\">\n          <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\"></a></div>\n\n        <img id=\"4-title\" class=\"halfScale\" style=\"top:81px;left:80px\" src=\"/109/es/static/_content/4-title.png\">\n\n        <img id=\"fourIpad\" class=\"halfScale fourIpad\" style=\"top:384px;left:594px\" src=\"/109/es/static/_content/4-ipad.png\">\n\n        <img class=\"cont-item cont-item-1-btn halfScale\" style=\"top:327px;left:572px;opacity:0\" src=\"/109/es/static/_content/4-edit.jpg\">\n        <img class=\"cont-item cont-item-2-btn halfScale\" style=\"top:338px;left:575px;opacity:0\" src=\"/109/es/static/_content/4-sport.jpg\">\n        <img class=\"cont-item cont-item-3-btn halfScale\" style=\"top:358px;left:574px;opacity:0\" src=\"/109/es/static/_content/4-prev.jpg\">\n        <img class=\"cont-item cont-item-4-btn halfScale\" style=\"top:351px;left:574px;opacity:0\" src=\"/109/es/static/_content/4-int.jpg\">\n        <img class=\"cont-item cont-item-5-btn halfScale\" style=\"top:328px;left:574px;opacity:0\" src=\"/109/es/static/_content/4-fie.jpg\">\n        <img class=\"cont-item cont-item-6-btn halfScale\" style=\"top:357px;left:574px;opacity:0\" src=\"/109/es/static/_content/4-news.jpg\">\n\n        <img id=\"4-next\" class=\"halfScale pointer\" style=\"top:940px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/4-arrow.png\">\n\n        <div class=\"addContentLink\" onclick=\"contentsBub(1);\" style=\"top:358px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(2);\" style=\"top:452px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(3);\" style=\"top:543px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(4);\" style=\"top:635px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(5);\" style=\"top:727px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(6);\" style=\"top:819px; left:84px; width: 492px; height: 60px;\"></div>\n\n        <div class=\"contentLink cont-item-1-link\" onclick=\"Publish.goToPage(6)\" style=\"top:357px;left:648px;width:568px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(8)\" style=\"top:357px;left:648px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(19)\" style=\"top:450px;left:649px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(44)\" style=\"top:541px;left:648px;width:724px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(49)\" style=\"top:634px;left:648px;width:532px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(52)\" style=\"top:726px;left:648px;width:471px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(55)\" style=\"top:817px;left:648px;width:471px;height:90px;display:none;\"></div>\n        <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(59); setTimeout(function(){showOverlay('59-pop-1');}, 200)\" style=\"top:726px;left:648px;width:759px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(59); setTimeout(function(){showOverlay('59-pop-2');}, 200)\" style=\"top:818px;left:648px;width:759px;height:64px;display:none;\"></div>\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n        \n        pg4Anim.fromTo(idOf(\"4-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)\n        .fromTo(idOf(\"4-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n      }\n  \n  \n      function contentsBub(index){\n        TweenMax.to(cOf(\"cont-hide\"), 0.5, {opacity:0})\n        console.log(\"contentsBub\", index)\n        for(var i=1; i <= 8; i++){\n          if(i == index){\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n              console.log(c)\n              c.style.display = \"\";\n            },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:1, onComplete:function(){\n              /*\n              classc(\"cont-item-\"+index+\"-link\")[0].style.display = \"\"\n              if(classc(\"cont-item-\"+index+\"-link\")[1]){\n                classc(\"cont-item-\"+index+\"-link\")[1].style.display = \"\"        \n              }\n              */\n            }});\n          }else{\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                c.style.display = \"none\";\n              },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:0});\n            TweenMax.to(cOf(\"fourIpad\"), 0.5, {opacity:0});\n          }\n        }\n      }\n  \n      function onPageLeave() {\n        pg4Anim.stop()\n        removeContentLinks()\n      }\n      ",
    "searchText": "ÍNDICE  EN ESTE NÚMERO  Le damos la bienvenida a la última edición de Escrime XXI, que llega repleta de las mejores imágenes, vídeos y artículos del mundo de la esgrima, y presenta una imagen totalmente fresca y renovada.  WWW.FIE.ORG  EDITORIAL  DEPORTE  Pulse los botones para revelar el contenido  VISTA PREVIA N˚109  ENTREVISTA  REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  NOTICIAS DE LA FIE Y DE LAS FEDERACIÓNES NACIONALES  NOTICIAS  JUNIOR Y CADETES CAMPEONATOS DEL MUNDO  YUKA UENO LA ESTRELLA EN ALZA GRAN PREMIO DOHA A EL CAIRO Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n      <img class=\"halfScale pointer 5-arrow\" style=\"top:854px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/5-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:54px\" src=\"/109/es/static/_content/5-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:124px\" src=\"/109/es/static/_content/5-social-fb.png\">\n      </a>\n      <a href=\"https://www.youtube.com/user/FIEvideo\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:192px\" src=\"/109/es/static/_content/5-social-yt.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"bottom:242px;left:745px;width:100px;height:26px;\">\n        <a href=\"mailto:info@fie.ch\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"bottom:213px;left:686px;width:105px;height:26px;\">\n          <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"bottom:154px;right:308px;width:212px;height:30px;\">\n          <a href=\"http://www.touchline.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax()\n          pg5Anim.fromTo(cOf(\"5-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "C OMITÉ E JECUTIVO DE L A FIE  Presidente: Alisher Usmanov (RUS) Secretario general: Emmanuel Katsiadakis (M.H.) (GRE) Secretaria tesorera: Ferial Nadira Salhi (ALG)  OFICINA CENTRAL DE LA FIE  Vicepresidentes: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Miembros: Erika Aze (LAT) Jacek Bierkowski (POL) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Wei Wang (CHN) Aldo Montano Presidente de la Comisión de Atletas de la FIE (ITA)  Administración  Directora general Nathalie Rodriguez M.-H. (FRA)  Directora administrativa: Elena Murdaca (ITA) Gestora de contabilidad: Sandra Baroni (SUI) Asistente de dirección: Gabrielle Meylan (BRA) Asistente administrativa: Ylenia Murdaca (ITA) Jefe de operaciones: Elena Huot (RUS) Deporte  Director técnico y deportivo: Evgeny Tsoukhlo (RUS)  Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS) Manager de operaciones del deporte: Sophie Treyvaud (SUI) Comunicación, Marketing, TV  Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) Presidente de la Confederación Asiática de Esgrima: Celso L. Dayrit (M.H.) (PHI) Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS) Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Jefe del gabinete del presidente: Nina Lalovic (SRB)  Manager digital y de comunicaciónes: Maria Ntanou (GRE)  Jefe de producción TV de la FIE: Barna Heder (HUN)  Asistente de producción TV de la FIE: Svetlana Krasnokoutskaya (RUS) Encargado de prensa: Serge Timacheff (USA) Fotógrafo: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG",
    "mobileHtml": "\n        <p>\n        <b>President</b>:<br> Alisher Usmanov (RUS)<br>\n        <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>\n        <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>\n        <p>\n        <b>Vice Presidents</b>:<br>\n        Ana Pascu (M.H.) (ROU)<br>\n        Donald Anthony (USA)<br>\n        Yuki Ota (JPN)<br></p>\n        <p>\n        <b>Members</b>:<br>\n        Erika Aze (LAT)<br>\n        Jacek Bierkowski (POL)<br>\n        Velichka Hristeva (BUL)<br>\n        Isabelle Lamour (FRA)<br>\n        Novak Perovic (RSA)<br>\n        Oleg Peskov (KAZ)<br>\n        Giorgio Scarso (ITA)<br>\n        Bence Szabo (HUN)<br>\n        Pascal Tesch (LUX)<br>\n        Wei WANG (CHN)<br>\n        Aldo Montano President of the FIE athletes commission (ITA)<br></p>\n\n        <p>\n          <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>\n          <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>\n          <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>\n          <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>\n          <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>\n        </p>\n        \n        <h2>FIE Head Office</h2>\n        <p>\n        <b>Chief Executive Officer</b><br>\n        Nathalie Rodriguez M.-H. (FRA)\n        </p>\n\n        <h2>Administration</h2>\n        <p>\n        <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>\n        <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>\n        <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>\n        <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>\n        <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>\n        </p>\n\n        <h2>Sport</h2>\n        <p>\n        <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>\n        <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>\n        <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>\n        </p>\n        <h2>Communication, Marketing, TV</h2>\n        <p>\n        <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>\n        <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>\n        <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>\n        <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>\n        <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>\n        <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>\n        </p>\n\n        <h2>Design</h2>\n        <p>\n        Touchline </b><br>\n        (<a href=\"http://www.touchline.com\" target=\"blank\">www.touchline.com</a>)\n        </p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,

    "content": "\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n        <img id=\"6-img\" class=\"halfScale\" style=\"top:308px;left:457px\" src=\"/109/es/static/_content/6-img.jpg\">\n        <img id=\"6-title\" class=\"halfScale\" style=\"top:719px;left:301px\" src=\"/109/es/static/_content/6-title.png\">\n\n        <img id=\"6-text-1\" class=\"halfScale\" style=\"top:310px;left:784px\" src=\"/109/es/static/_content/6-text-1.png\">\n        <img id=\"6-text-2\" class=\"halfScale\" style=\"top:310px;left:199px; opacity:0;\" src=\"/109/es/static/_content/6-text-2.png\">\n\n        <img id=\"6-cta-1\" class=\"halfScale pointer\" style=\"top:820px;left:784px\" onclick=\"toggleText6(false);\" src=\"/109/es/static/_content/6-p1.png\">\n        <img id=\"6-cta-2\" class=\"halfScale pointer\" style=\"top:820px;left:1063px;opacity:0\" onclick=\"toggleText6(true);\" src=\"/109/es/static/_content/6-p2.png\">\n\n        <img id=\"6-next\" class=\"halfScale pointer\" style=\"top:938px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/6-arrow.png\">\n      ",
    "script": "\n      function onPageEnter(){\n        pg6Anim = new TimelineMax();\n        pg6Anim.fromTo(idOf(\"6-img\"), 0.5,{opacity:0}, {opacity:1},0.5)\n            .fromTo(idOf(\"6-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},\"-=0.2\")\n            .fromTo(idOf(\"6-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},\"+=0.3\")\n      }\n\n      function toggleText6(bool){\n        var text1 = idOf(\"6-text-1\");\n        var text2 = idOf(\"6-text-2\");\n        \n        if(!bool && text1.style.opacity == \"0\"){\n          pg6Anim.play();\n          TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:0}, {opacity:1});\n        }else if(bool && text2.style.opacity == \"0\"){\n          pg6Anim.pause();\n          TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:1}, {opacity:0});\n        }\n      }\n\n      function onPageLeave(){\n        if(idOf(\"6-text-1\").style.opacity == \"0\"){\n          toggleText6(false);\n        }\n        pg6Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "PRÓLO GO  Estimados compañeros tiradores: Tengo el placer de redactar una breve introducción para la próxima edición de la Revista de la FIE.  TODA LA ATENCIÓN EN LA ESGRIMA  Hemos entrado en el tercer año del cuatrienio olímpico. La FIE, la federación nacional, los tiradores y los entrenadores han centrado su atención en los Juegos Olímpicos de Tokio 2020, evento en el que, por primera vez en nuestra historia, los tiradores y los equipos nacionales competirán en doce pruebas tanto por equipos como individuales, que se celebrarán en las tres armas, en pruebas masculinas y femeninas. Este es el reconocimiento al desarrollo de nuestro amado deporte por parte  PÁGINA 1  PÁGINA 2  W W W.FIE .ORG",
    "mobileHtml": "\n      <h2>TODA LA ATENCI\xD3N EN LA ESGRIMA</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg6-fore.jpg\">\n      <p><b>Estimados compa\xF1eros tiradores:</b></p>\n      <p>Tengo el placer de redactar una breve introducci\xF3n para la pr\xF3xima edici\xF3n de la revista de la FIE.</p>\n      <p>Hemos entrado en el tercer a\xF1o del cuatrienio ol\xEDmpico. La FIE, la federaci\xF3n nacional, los tiradores y los entrenadores han centrado su atenci\xF3n en los Juegos Ol\xEDmpicos de Tokio 2020, evento en el que, por primera vez en nuestra historia, los tiradores y los equipos nacionales competir\xE1n en doce pruebas tanto por equipos como individuales, que se celebrar\xE1n en las tres armas, en pruebas masculinas y femeninas.  Este es el reconocimiento al desarrollo de nuestro amado deporte por parte del Comit\xE9 Ol\xEDmpico Internacional. Es nuestro gran logro, pero tambi\xE9n representa el mayor desaf\xEDo para todos nosotros.</p>\n      <p>En nuestro mundo en r\xE1pida evoluci\xF3n, estaremos preparados y dispuestos a seguir adapt\xE1ndonos y progresando, a adoptar nuevas tendencias y a animarnos para un cambio. Nos centraremos en atraer a nuevos p\xFAblicos, a m\xE1s espectadores y aficionados a nuestras competencias; en implicar a nuevas personas, y en hacer que la esgrima sea m\xE1s popular entre los ni\xF1os y los adolescentes. Hace solo unos a\xF1os nos centramos en hacer la esgrima m\xE1s atractiva para la televisi\xF3n. Ahora nuestro mayor desaf\xEDo es lograr que la esgrima sea m\xE1s popular en el mundo digital y en las redes sociales. Esta es nuestra principal misi\xF3n para 2019.</p>\n      <p>Tendremos una presencia igualmente s\xF3lida de j\xF3venes tiradores en los pr\xF3ximos Campeonatos del Mundo de Esgrima Juvenil y Cadete en Torun, junto con el Campeonato del Mundo de Esgrima Senior en Budapest. Adem\xE1s, con programas s\xF3lidos y eficaces como el \xABDonate Your Fencing Gear\xBB de la FIE, que conecta a los atletas de \xE9lite con las federaciones emergentes y necesitadas, m\xE1s tiradores de nuevas regiones est\xE1n compitiendo a nivel local, nacional e internacional.</p>\n      <p>Deseo que todos ustedes alcancen sus sue\xF1os de esgrima, y que todos nosotros consigamos que la esgrima sea a\xFAn m\xE1s popular y atractiva.</p>\n      <p><b>Alisher Usmanov<br>Presidente de la FIE</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:80px;right:680px;width:480px; height:48px;\">\n          <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.absolutefencinggear.com\">\n        <img src=\"/109/es/static/_mobile/7.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 8-title\" style=\"top:56px;left:978px\" src=\"/109/es/static/_content/8-title.png\">\n\n      <img class=\"halfScale 8-line\" style=\"top:611px;left:985px\" src=\"/109/es/static/_content/8-line.png\">\n\n      <img class=\"halfScale 8-sub\" style=\"top:612px;left:1027px\" src=\"/109/es/static/_content/8-sub.png\">\n\n      <img class=\"halfScale pointer 8-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax()\n          pg8Anim\n            .fromTo(cOf(\"8-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"8-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop()\n        }\n      ",
    "searchText": "GR AN PREMIO  BOREL Y BELJAJEVA GANAN LA MEDALLA DE ORO DEL GRAN PREMIO DE ESGRIMA DE ESPADA DOHA, CATAR 27 DE ENERO DE 2019",
    "mobileHtml": "\n        <h2>BOREL Y BELJAJEVA GANAN LA MEDALLADE ORO DEL GRAN PREMIO DE ESGRIMA DE ESPADA</h2>\n        <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg8-doha.jpg\">\n        <p><b>DOHA, CATAR <br>\n        27 DE ENERO DE 2019<br>\n        </b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 9-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax()\n          pg9Anim\n            .fromTo(cOf(\"9-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop()\n        }\n      ",
    "searchText": "GRAN PREMIO DOHA, CATAR 2/3  Más de 350 esgrimistas internacionales, hombres y mujeres, compitieron en Doha en el Gran Premio de espada de Catar de 2019, con dos campeones del mundo, el francés Yannick Borel y la estonia Julia Beljajeva, que se llevaron la medalla de oro. El Gran Premio de Catar es el primero de una serie de nueve que se celebrarán en todo el mundo a lo largo de la temporada 2018-2019 de la Federación Internacional de Esgrima (FIE). Tuvo lugar en la sala de «Aspire Zone» del Aspire Dome de Doha. Espada masculina En la competición individual masculina de espada, Borel se enfrentó al español Yulen Pereira y consiguió la medalla de oro con un resultado final de 15-4. Pereira derrotó al ucraniano Bogdan Nikishin en la semifinal, por 15-9, y Borel venció al estadounidense Jacob Hoyle, por 15-10. Cabe destacar que el campeón olímpico coreano Sangyoung Park perdió ante el francés Ronan Gustin en octavos de final por un solo toque, por 15-14. Gustin fue derrotado por Pereira en cuartos de final, por 15-12.",
    "mobileHtml": "\n      <p><b>M\xE1s de 350 esgrimistas internacionales, hombres y mujeres, compitieron en Doha en el Gran Premio de espada de Catar de 2019, con dos campeones del mundo, el franc\xE9s Yannick Borel y la estonia Julia Beljajeva, que se llevaron la medalla de oro.</b></p>\n      <p>El Gran Premio de Catar es el primero de una serie de nueve que se celebrar\xE1n en todo el mundo a lo largo de la temporada 2018-2019 de la Federaci\xF3n Internacional de Esgrima (FIE). Tuvo lugar en la sala de \xABAspire Zone\xBB del Aspire Dome de Doha.</p>\n\n      <p><b>Espada masculina</b></p>\n      <p>En la competici\xF3n individual masculina de espada, Borel se enfrent\xF3 al espa\xF1ol Yulen Pereira y consigui\xF3 la medalla de oro con un resultado final de 15-4. Pereira derrot\xF3 al ucraniano Bogdan Nikishin en la semifinal, por 15-9, y Borel venci\xF3 al estadounidense Jacob Hoyle, por 15-10. Cabe destacar que el campe\xF3n ol\xEDmpico coreano Sangyoung Park perdi\xF3 ante el franc\xE9s Ronan Gustin en octavos de final por un solo toque, por 15-14. Gustin fue derrotado por Pereira en cuartos de final, por 15-12.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      \n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n      <img class=\"halfScale pointer 10-arrow\" style=\"top:846px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/10-arrow.png\">\n      \n      <a href=\"https://fie.us15.list-manage.com/track/click?u=43e998d71622bc3f6aeddee10&id=1902386954&e=0ff8939683\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:754px;left:61px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      <a href=\"http://fie.org/\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:907px;left:59px\" src=\"/109/es/static/_content/10-tap-info.png\">\n      </a>\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax()\n          pg10Anim\n            .fromTo(cOf(\"10-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "GRAN PREMIO DOHA, CATAR 3/3  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA  Pulse aquí para obtener más INFORMACIÓN  Espada femenina En la competición individual de espada femenina, Beljajeva se enfrentó a la ucraniana Kseniya Pantelyeyeva y ganó con un marcador final de 15-11. Para la ucraniana, fue la mejor final de su carrera. Se impuso a la rusa Violetta Kolobova en la semifinal, por 15-12, mientras que Beljajeva venció a la coreana Hyojung Jung, por 15-6. La actual campeona del mundo, la italiana Mara Navarria, perdió frente a Beljajeva en octavos de final, por 15-12.  Los ocho finalistas de espada individual masculina en el Gran Premio de Catar fueron Yannick Borel (FRA, oro), Yulen Pereira (ESP, plata), Jacob Hoyle (USA, bronce), Bogdan Nikishin (UKR, bronce), Roman Svichkar (UKR), Ronan Gustin (FRA), Ido Harper (ISR) y Sergey Bida (RUS). Las ocho finalistas femeninas fueron Julia Beljajeva (EST, oro), Kseniya Pantelyeyeva (UKR, plata), Hyojung Jung (KOR, bronce), Violetta Kolobova (RUS, bronce), Mingye Zhu (CHN), Ewa Trzebinska (POL), Pauline Brunner (SUI) y Yana Shemyakina (UKR). ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>Espada femenina</b></p>\n      <p>En la competici\xF3n individual de espada femenina, Beljajeva se enfrent\xF3 a la ucraniana Kseniya Pantelyeyeva y gan\xF3 con un marcador final de 15-11. Para la ucraniana, fue la mejor final de su carrera. Se impuso a la rusa Violetta Kolobova en la semifinal, por 15-12, mientras que Beljajeva venci\xF3 a la coreana Hyojung Jung, por 15-6. La actual campeona del mundo, la italiana Mara Navarria, perdi\xF3 frente a Beljajeva en octavos de final, por 15-12.</p>\n      <p>Los ocho finalistas de espada individual masculina en el Gran Premio de Catar fueron Yannick Borel (FRA, oro), Yulen Pereira (ESP, plata), Jacob Hoyle (USA, bronce), Bogdan Nikishin (UKR, bronce), Roman Svichkar (UKR), Ronan Gustin (FRA), Ido Harper (ISR) y Sergey Bida (RUS).</p>\n      <p>Las ocho finalistas femeninas fueron Julia Beljajeva (EST, oro), Kseniya Pantelyeyeva (UKR, plata), Hyojung Jung (KOR, bronce), Violetta Kolobova (RUS, bronce), Mingye Zhu (CHN), Ewa Trzebinska (POL), Pauline Brunner (SUI) y Yana Shemyakina (UKR).</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 11-title\" style=\"top:109px;left:410px\" src=\"/109/es/static/_content/11-title.png\">\n\n      <img class=\"halfScale 11-line\" style=\"top:339px;left:416px\" src=\"/109/es/static/_content/11-line.png\">\n\n      <img class=\"halfScale 11-sub\" style=\"top:332px;left:458px\" src=\"/109/es/static/_content/11-sub.png\">\n\n      <img class=\"halfScale pointer 11-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax()\n          pg11Anim\n          .fromTo(cOf(\"11-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"11-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"11-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"11-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop()\n        }\n      ",
    "searchText": "GR AND PRIX  IMBODEN AND VOLPI TAKE FOIL GRAND PRIX GOLD TORINO, ITALY FEBRUARY 10, 2019",
    "mobileHtml": "\n      <h2>IMBODEN Y VOLPI SE LLEVAN EL ORO EN LOS GRANDES PREMIOS DE FLORETE </h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg11-torino.jpg\">\n      <p><b>TUR\xCDN, ITALIA<br>10 DE FEBRERO DE 2019<br>\n      </b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 12-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n        ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax()\n          pg12Anim\n            .fromTo(cOf(\"12-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop()\n        }\n      ",
    "searchText": "GRAN PREMIO TURÍN, ITALIA 2/3  Varios cientos de tiradores de florete internacionales masculinos y femeninos compitieron en los Grandes Premios de Florete de la FIE en Turín, Italia, donde Race Imboden de EE. UU. y Alice Volpi de Italia ganaron medallas de oro en las pruebas individuales.  La segunda de una serie de nueve pruebas de la competencia de esgrima de los Grandes Premios de la FIE, tuvo lugar en el Pala Alpitour de Turín (Palasport Olimpico), el mayor estadio deportivo cubierto de Italia y construido originalmente para los Juegos Olímpicos de Invierno de 2006. Florete masculino Imboden se enfrentó al hongkonés Ka Long Cheung en el encuentro final y venció con un resultado de 15-6. Compitieron aproximadamente 220 floretistas masculinos, entre ellos varios atletas campeones del mundo y olímpicos. En semifinales, Cheung derrotó al estadounidense Gerek Meinhardt, por 15-12, mientras que Imboden superó al campeón del mundo italiano Alessio Foconi por 15-13. Imboden también venció al campeón del mundo de Rusia Alexey Cheremisinov en cuartos de final, por 15-13. En particular, Meinhardt superó al campeón del mundo italiano Andrea Cassara en la ronda 16, por 15-13, y el vigente campeón olímpico italiano Daniele Garozzo fue derrotado en la ronda 32 por el polaco Michal Siess, por 15-7.",
    "mobileHtml": "\n      <p><b>Varios cientos de tiradores de florete internacionales masculinos y femeninos compitieron en los Grandes Premios de Florete de la FIE en Tur\xEDn, Italia, donde Race Imboden de EE. UU. y Alice Volpi de Italia ganaron medallas de oro en las pruebas individuales.</b></p>\n      <p>La segunda de una serie de nueve pruebas de la competencia de esgrima de los Grandes Premios de la FIE, tuvo lugar en el Pala Alpitour de Tur\xEDn (Palasport Olimpico), el mayor estadio deportivo cubierto de Italia y construido originalmente para los Juegos Ol\xEDmpicos de Invierno de 2006.</p>\n      <p><b>Florete masculino</b></p>\n      <p>Imboden se enfrent\xF3 al hongkon\xE9s Ka Long Cheung en el encuentro final y venci\xF3 con un resultado de 15-6. Compitieron aproximadamente 220 floretistas masculinos, entre ellos varios atletas campeones del mundo y ol\xEDmpicos. En semifinales, Cheung derrot\xF3 al estadounidense Gerek Meinhardt, por 15-12, mientras que Imboden super\xF3 al campe\xF3n del mundo italiano Alessio Foconi por 15-13. Imboden tambi\xE9n venci\xF3 al campe\xF3n del mundo de Rusia Alexey Cheremisinov en cuartos de final, por 15-13. En particular, Meinhardt super\xF3 al campe\xF3n del mundo italiano Andrea Cassara en la ronda 16, por 15-13, y el vigente campe\xF3n ol\xEDmpico italiano Daniele Garozzo fue derrotado en la ronda 32 por el polaco Michal Siess, por 15-7.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 13-arrow\" style=\"top:846px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/10-arrow.png\">\n      \n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=GP&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=ITA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:753px;left:61px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      <a href=\"http://fie.org/\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:906px;left:59px\" src=\"/109/es/static/_content/10-tap-info.png\">\n      </a>\n      \n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax()\n          pg13Anim\n            .fromTo(cOf(\"13-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: removeContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop()\n        }\n      ",
    "searchText": "GRAN PREMIO TURÍN, ITALIA 3/3  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA  Pulse aquí para obtener más INFORMACIÓN  Florete femenino Con aproximadamente 170 tiradores en duelo en la prueba de florete individual femenina, el encuentro final contó con la presencia de las compañeras de equipo italianas Alice Volpi y Elisa Di Francisca, que se enfrentaron para conseguir la medalla de oro. La vigente campeona del mundo Volpi derrotó a la campeona del mundo y campeona olímpica Di Francisca por la medalla de oro, por 15-9. Di Francisca venció a otra compañera de equipo, Francesca Palumbo, en la semifinal, por 15-7, mientras que Volpi venció a la rusa Anastasiia Ivanova, por 15-12. Palumbo derrotó a la bicampeona mundial y campeona olímpica Inna Deriglazova en cuartos de final, por 15-5.  Los ocho primeros clasificados en la prueba de florete masculino de los Grandes Premios de Turín incluyeron a Race Imboden (EE. UU., oro), Ka Long Cheung (HKG, plata), Alessio Foconi (ITA, bronce), Gerek Meinhardt (EE. UU., bronce), Alexey Cheremisinov (RUS), Timur Safin (RUS), Alexander Massialas (EE. UU.) y Giorgio Avola (ITA). Las ocho primeras clasificadas incluyeron a Alice Volpi (ITA, oro), Elisa Di Francisca (ITA, plata), Anastasiia Ivanova (RUS, bronce), Francesca Palumbo (ITA, bronce), Inna Deriglazova (RUS), Leonie Ebert (GER), Camilla Mancini (ITA) y Larisa Korobeynikova (RUS). ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>Florete femenino</b></p>\n      <p>Con aproximadamente 170 tiradores en duelo en la prueba de florete individual femenina, el encuentro final cont\xF3 con la presencia de las compa\xF1eras de equipo italianas Alice Volpi y Elisa Di Francisca, que se enfrentaron para conseguir la medalla de oro. La vigente campeona del mundo Volpi derrot\xF3 a la campeona del mundo y campeona ol\xEDmpica Di Francisca por la medalla de oro, por 15-9. Di Francisca venci\xF3 a otra compa\xF1era de equipo, Francesca Palumbo, en la semifinal, por 15-7, mientras que Volpi venci\xF3 a la rusa Anastasiia Ivanova, por 15-12. Palumbo derrot\xF3 a la bicampeona mundial y campeona ol\xEDmpica Inna Deriglazova en cuartos de final, por 15-5.</p>\n      <p>Los ocho primeros clasificados en la prueba de florete masculino de los Grandes Premios de Tur\xEDn incluyeron a Race Imboden (EE. UU., oro), Ka Long Cheung (HKG, plata), Alessio Foconi (ITA, bronce), Gerek Meinhardt (EE. UU., bronce), Alexey Cheremisinov (RUS), Timur Safin (RUS), Alexander Massialas (EE. UU.) y Giorgio Avola (ITA).</p>\n      <p>Las ocho primeras clasificadas incluyeron a Alice Volpi (ITA, oro), Elisa Di Francisca (ITA, plata), Anastasiia Ivanova (RUS, bronce), Francesca Palumbo (ITA, bronce), Inna Deriglazova (RUS), Leonie Ebert (GER), Camilla Mancini (ITA) y Larisa Korobeynikova (RUS).</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 14-title\" style=\"top:116px;left:86px\" src=\"/109/es/static/_content/14-title.png\">\n\n      <img class=\"halfScale 14-line\" style=\"top:340px;left:97px\" src=\"/109/es/static/_content/14-line.png\">\n\n      <img class=\"halfScale 14-sub\" style=\"top:339px;left:139px\" src=\"/109/es/static/_content/14-sub.png\">\n\n      <img class=\"halfScale pointer 14-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax()\n          pg14Anim\n          .fromTo(cOf(\"14-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"14-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"14-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"14-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop()\n        }\n      ",
    "searchText": "GRAN PREMIO  EL ORO EN SABLE DE LOS GRANDES PREMIOS PARA OH DE COREA Y VELIKAYA DE RUSIA EL CAIRO, EGIPTO 24 DE FEBRERO DE 2019",
    "mobileHtml": "\n      <h2>EL ORO EN SABLE DE LOS GRANDES PREMIOS PARA OH DE COREA Y VELIKAYA DE RUSIA</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg14-cairo.jpg\">\n      <p><b>EL CAIRO, EGIPTO<br>24 DE FEBRERO DE 2019<br>\n      </b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 15-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax()\n          pg15Anim\n            .fromTo(cOf(\"15-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop()\n        }\n      ",
    "searchText": "GRAN PREMIO EL CAIRO, EGIPTO 2/3  La coreana Sanguk Oh y la rusa Sofya Velikaya ganaron medallas de oro individuales en los Grandes Premios de Sable de El Cairo de 2019. Más de 270 tiradores internacionales, hombres y mujeres, compitieron en la prueba, que tuvo lugar en el Estadio de El Cairo. Sable masculino Oh se enfrentó al dos veces medallista de oro olímpico húngaro Aron Szilagyi en el encuentro final de la competencia masculina, ganando con un resultado de 15-10. Szilagyi venció al georgiano Sandro Bazadze en la semifinal, por  15-5, y Oh superó a su compañero de equipo, Junho Kim, por 15-7. Bazadze derrotó al primer clasificado estadounidense Eli Dershwitz en cuartos de final por 15-12, mientras que Dershwitz venció a la campeona del mundo rusa Veniamin Reshetnikov en la ronda 16 por un punto, por 15-14.",
    "mobileHtml": "\n      <p><b>La coreana Sanguk Oh y la rusa Sofya Velikaya ganaron medallas de oro individuales en los Grandes Premios de Sable de El Cairo de 2019.</b></p>\n      <p>M\xE1s de 270 tiradores internacionales, hombres y mujeres, compitieron en la prueba, que tuvo lugar en el Estadio de El Cairo.</p>\n      <p><b>Sable masculino</b></p>\n      <p>Oh se enfrent\xF3 al dos veces medallista de oro ol\xEDmpico h\xFAngaro Aron Szilagyi en el encuentro final de la competencia masculina, ganando con un resultado de 15-10. Szilagyi venci\xF3 al georgiano Sandro Bazadze en la semifinal, por 15-5, y Oh super\xF3 a su compa\xF1ero de equipo, Junho Kim, por 15-7. Bazadze derrot\xF3 al primer clasificado estadounidense Eli Dershwitz en cuartos de final por 15-12, mientras que Dershwitz venci\xF3 al campe\xF3n del mundo ruso Veniamin Reshetnikov en la ronda 16 por un punto, por 15-14.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 16-arrow\" style=\"top:846px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/10-arrow.png\">\n\n      <a href=\"https://fie.us15.list-manage.com/track/click?u=43e998d71622bc3f6aeddee10&id=4c7e1655ec&e=0ff8939683\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:755px;left:61px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      <a href=\"http://fie.org/\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:909px;left:59px\" src=\"/109/es/static/_content/10-tap-info.png\">\n      </a>\n      \n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax()\n          pg16Anim\n            .fromTo(cOf(\"16-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "GRAN PREMIO EL CAIRO, EGIPTO 3/3  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA  Pulse aquí para obtener más INFORMACIÓN  Sable femenino Sofya Velikaya, dos veces campeona del mundo rusa y dos veces medalla de plata olímpica, se impuso a Sooyeon Choi, de Corea, en la ronda de medallas de oro de la prueba femenina, y terminó con un resultado de 15-12. Choi derrotó a la tricampeona del mundo ucraniana Olga Kharlan por un solo punto en el encuentro de semifinales, por 15-14, mientras que Velikaya anotó la victoria en otro match reñido frente a la francesa Cecilia Berder, por 15-14. En particular, la actual campeona del mundo rusa, Sofia Pozdniakova, derrotó a la dos veces medallista de oro olímpica estadounidense y a la doble campeona del mundo Mariel Zagunis en la ronda 32, por 15-8; Pozdniakova fue entonces superada por la china Yaqi Shao en la ronda 16, por 15-9. Shao perdió ante Kharlan en cuartos de final, por 15-6.  Los ocho primeros clasificados de los Grandes Premios de Sable de El Cairo de 2019 incluyen a Sanguk Oh (KOR, oro), Aron Szilagyi (HUN, plata), Sandro Bazadze (GEO, bronce), Junho Kim (KOR, bronce), Eli Dershwitz (EE. UU.), Max Hartung (GER), Dmitriy Danilenko (RUS) y Vincent Anstett (FRA). Entre los ocho primeros puestos de la clasificación femenina se encuentran Sofya Velikaya (RUS, oro), Sooyeon Choi (KOR, plata), Cecilia Berder (FRA, bronce), Olga Kharlan (UKR, bronce), Anne-Elizabeth Stone (EE. UU.), Liza Pusztai (HUN), Manon Brunet (FRA) y Yaqi Shao (CHN). ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>Sable femenino</b></p>\n      <p>Sofya Velikaya, dos veces campeona del mundo rusa y dos veces medalla de plata ol\xEDmpica, se impuso a Sooyeon Choi, de Corea, en la ronda de medallas de oro de la prueba femenina, y termin\xF3 con un resultado de 15-12. Choi derrot\xF3 a la tricampeona del mundo ucraniana Olga Kharlan por un solo punto en el encuentro de semifinales, por 15-14, mientras que Velikaya anot\xF3 la victoria en otro match re\xF1ido frente a la francesa Cecilia Berder, por 15-14. En particular, la actual campeona del mundo rusa, Sofia Pozdniakova, derrot\xF3 a la dos veces medallista de oro ol\xEDmpica estadounidense y a la doble campeona del mundo Mariel Zagunis en la ronda 32, por 15-8; Pozdniakova fue entonces superada por la china Yaqi Shao en la ronda 16, por 15-9. Shao perdi\xF3 ante Kharlan en cuartos de final, por 15-6.</p>\n      <p>Los ocho primeros clasificados de los Grandes Premios de Sable de El Cairo de 2019 incluyen a Sanguk Oh (KOR, oro), Aron Szilagyi (HUN, plata), Sandro Bazadze (GEO, bronce), Junho Kim (KOR, bronce), Eli Dershwitz (EE. UU.), Max Hartung (GER), Dmitriy Danilenko (RUS) y Vincent Anstett (FRA).</p>\n      <p>Entre los ocho primeros puestos de la clasificaci\xF3n femenina se encuentran Sofya Velikaya (RUS, oro), Sooyeon Choi (KOR, plata), Cecilia Berder (FRA, bronce), Olga Kharlan (UKR, bronce), Anne-Elizabeth Stone (EE. UU.), Liza Pusztai (HUN), Manon Brunet (FRA) y Yaqi Shao (CHN).</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.openVideo('/109/es/static/_content/11-vid.m4v')\" style=\"bottom:460px;left:1146px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.allstar.de\" target=\"_blank\">\n        <img src=\"/109/es/static/_mobile/17.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLink\" style=\"bottom:324px;right:1050px;width:264px; height:48px;\">\n          <a href=\"https://www.blaise-freres.fr\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/109/es/static/_mobile/18.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 19-title\" style=\"top:115px;left:620px\" src=\"/109/es/static/_content/19-title.png\">\n\n      <img class=\"halfScale 19-line\" style=\"top:349px;left:625px\" src=\"/109/es/static/_content/19-line.png\">\n\n      <img class=\"halfScale 19-sub\" style=\"top:349px;left:667px\" src=\"/109/es/static/_content/19-sub.png\">\n\n      <img class=\"halfScale pointer 19-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax()\n          pg19Anim\n          .fromTo(cOf(\"19-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"19-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"19-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"19-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO  COPA DEL MUNDO DE ESGRIMA SENIOR 2019 12 DE ENERO-10 DE FEBRERO DE 2019",
    "mobileHtml": "\n\n      <h2>COPA DEL MUNDO DE ESGRIMA SENIOR 2019</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg19-world-cup.jpg\">\n      <p><b>12 DE ENERO-10 DE FEBRERO DE 2019</b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 20-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax()\n          pg20Anim\n            .fromTo(cOf(\"20-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA MASCULINA 2/21  ESPADA MASCULINA HEIDENHEIM, ALEMANIA 12 DE ENERO DE 2019  El esgrimista francés Alexandre Bardenet se ha llevado el oro en la primera copa del mundo de esgrima senior de 2019 en el Heidenheimer Pokal de Heidenheim, Alemania. Cerca de 325 esgrimistas de todo el mundo participaron en la competición de espada masculina. Rusia ganó la medalla de oro de la competición de espada masculina por equipos, la «Copa Voith», en la  que compitieron 37 países. La competición se celebró en el Congress Centrum de Heidenheim. Bardenet derrotó al italiano Davide Di Veroli en la ronda final de la competición individual masculina de espada, por 15-7. En semifinales",
    "mobileHtml": "\n      <p><b>ESPADA MASCULINA <br>HEIDENHEIM, ALEMANIA<br>12 DE ENERO DE 2019<br>\n      </b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg20-heidenheim.jpg\">\n      <p>El esgrimista franc\xE9s Alexandre Bardenet se ha llevado el oro en la primera copa del mundo de esgrima senior de 2019 en el Heidenheimer Pokal de Heidenheim, Alemania. Cerca de 325 esgrimistas de todo el mundo participaron en la competici\xF3n de espada masculina. Rusia gan\xF3 la medalla de oro de la competici\xF3n de espada masculina por equipos, la \xABCopa Voith\xBB, en la que compitieron 37 pa\xEDses. La competici\xF3n se celebr\xF3 en el Congress Centrum de Heidenheim.</p>\n      <p>Bardenet derrot\xF3 al italiano Davide Di Veroli en la ronda final de la competici\xF3n individual masculina de espada, por 15-7. En semifinales, Di Veroli venci\xF3 al japon\xE9s Koki Kano en un combate re\xF1ido, por 9-8, mientras que Bardenet lleg\xF3 a la final tras superar al ruso Georgiy Bruev, por 15-11.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 21-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=E&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=GER&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:889px;left:61px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax()\n          pg21Anim\n            .fromTo(cOf(\"21-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA MASCULINA 3/21  Di Veroli venció al japonés Koki Kano en un combate reñido, por 9-8, mientras que Bardenet llegó a la final tras superar al ruso Georgiy Bruev, por 15-11.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  En la prueba de espada por equipos masculina, Rusia venció a Hungría en la final, por 35-30. Hungría derrotó a Polonia en la semifinal, por 41-32, mientras que Rusia superó a Italia por un punto, por 45-44. La medalla de bronce se la llevó Italia tras ganar contra Polonia, por 45-31. Los ocho finalistas de la Copa del Mundo del Heidenheimer Pokal fueron Alexandre Bardenet  (FRA, oro), Davide Di Veroli (ITA, plata), Georgiy Bruev (RUS, bronce), Koki Kano (JPN, bronce), Ido Harper (ISR), Gabriele Cimini (ITA), Jacob Hoyle (USA) y David Nagy (HUN). Los ocho mejores equipos clasificados en la competición de espada masculina fueron Rusia (oro), Hungría (plata), Italia (bronce), Polonia, Corea, Estados Unidos, Israel y Suiza.",
    "mobileHtml": "\n      <p>En la prueba de espada por equipos masculina, Rusia venci\xF3 a Hungr\xEDa en la final, por 35-30. Hungr\xEDa derrot\xF3 a Polonia en la semifinal, por 41-32, mientras que Rusia super\xF3 a Italia por un punto, por 45-44. La medalla de bronce se la llev\xF3 Italia tras ganar contra Polonia, por 45-31.</p>\n      <p>Los ocho finalistas de la Copa del Mundo del Heidenheimer Pokal fueron Alexandre Bardenet (FRA, oro), Davide Di Veroli (ITA, plata), Georgiy Bruev (RUS, bronce), Koki Kano (JPN, bronce), Ido Harper (ISR), Gabriele Cimini (ITA), Jacob Hoyle (USA) y David Nagy (HUN).</p>\n      <p>Los ocho mejores equipos clasificados en la competici\xF3n de espada masculina fueron Rusia (oro), Hungr\xEDa (plata), Italia (bronce), Polonia, Corea, Estados Unidos, Israel y Suiza.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 22-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax()\n          pg20Anim\n            .fromTo(cOf(\"22-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE MASCULINO 4/21  FLORETE MASCULINO PARÍS, FRANCIA 13 DE ENERO DE 2019  El campeón del mundo de esgrima italiano, Alessio Foconi, llevó el oro en la Copa del Mundo de florete masculino del Challenge International de Paris (CIP), mientras que Rusia consiguió el oro en la competición de florete masculino por equipos. La competición, que tuvo lugar en el Stade Pierre de Coubertin, atrajo a más de 250 esgrimistas individuales de primera categoría y a 30 equipos. Foconi se enfrentó al estadounidense Gerek Meinhardt en el último combate y ganó con un resultado de 15-12. Meinhardt venció al italiano Giorgio Avola en la semifinal, por 15-13, mientras que Foconi derrotó al estadounidense Race Imboden, por 15-12. Destaca la victoria de Avola sobre su compañero de equipo y medallista de oro olímpico, Daniele Garozzo, en cuartos de final, por 15-12. En la competición por equipos de florete masculino, Rusia se llevó la medalla de oro frente a Italia, por 45-40. Italia venció a Corea en la semifinal, por 45-33, mientras que Rusia derrotó a Estados Unidos, por 45-36. El equipo de Estados Unidos consiguió la medalla de bronce tras vencer a Corea, por 45-41.",
    "mobileHtml": "\n      <p><b>FLORETE MASCULINO<br>\n      PAR\xCDS, FRANCIA<br>\n      13 DE ENERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg22-paris.jpg\">\n      <p>El campe\xF3n del mundo de esgrima italiano, Alessio Foconi, llev\xF3 el oro en la Copa del Mundo de florete masculino del Challenge International de Paris (CIP), mientras que Rusia consigui\xF3 el oro en la competici\xF3n de florete masculino por equipos. La competici\xF3n, que tuvo lugar en el Stade Pierre de Coubertin, atrajo a m\xE1s de 250 esgrimistas individuales de primera categor\xEDa y a 30 equipos.</p>\n      <p>Foconi se enfrent\xF3 al estadounidense Gerek Meinhardt en el \xFAltimo combate y gan\xF3 con un resultado de 15-12. Meinhardt venci\xF3 al italiano Giorgio Avola en la semifinal, por 15-13, mientras que Foconi derrot\xF3 al estadounidense Race Imboden, por 15-12. Destaca la victoria de Avola sobre su compa\xF1ero de equipo y medallista de oro ol\xEDmpico, Daniele Garozzo, en cuartos de final, por 15-12.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 23-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=FRA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:890px;left:60px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax()\n          pg23Anim\n            .fromTo(cOf(\"23-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE MASCULINO 5/21  Los ocho finalistas de la Copa del Mundo de florete masculino del Challenge International de Paris fueron Alessio Foconi (ITA, oro), Gerek Meinhardt (USA, plata), Giorgio Avola (ITA, bronce), Race Imboden (USA, bronce), Daniele Garozzo (ITA), Alexander Massialas (USA), Erwann Le Pechoux (FRA) y Edoardo Luperi (ITA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Los ocho países mejor clasificados en la competición de florete masculino por equipos fueron Rusia (oro), Italia (plata), Estados Unidos (bronce), Corea, Francia, Japón, Hong Kong y Polonia.",
    "mobileHtml": "\n      <p>En la competici\xF3n por equipos de florete masculino, Rusia se llev\xF3 la medalla de oro frente a Italia, por 45-40. Italia venci\xF3 a Corea en la semifinal, por 45-33, mientras que Rusia derrot\xF3 a Estados Unidos, por 45-36. El equipo de Estados Unidos consigui\xF3 la medalla de bronce tras vencer a Corea, por 45-41.</p>\n      <p>Los ocho finalistas de la Copa del Mundo de florete masculino del Challenge International de Paris fueron Alessio Foconi (ITA, oro), Gerek Meinhardt (USA, plata), Giorgio Avola (ITA, bronce), Race Imboden (USA, bronce), Daniele Garozzo (ITA), Alexander Massialas (USA), Erwann Le Pechoux (FRA) y Edoardo Luperi (ITA).</p>\n      <p>Los ocho pa\xEDses mejor clasificados en la competici\xF3n de florete masculino por equipos fueron Rusia (oro), Italia (plata), Estados Unidos (bronce), Corea, Francia, Jap\xF3n, Hong Kong y Polonia.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 24-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax()\n          pg24Anim\n            .fromTo(cOf(\"24-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE FEMENINO 6/21  FLORETE FEMENINO KATOWICE, POLONIA 13 DE ENERO DE 2019  La bicampeona del mundo y medallista de oro olímpica rusa Inna Deriglazova ha conseguido la medalla de oro en la Copa del Mundo de florete femenino en Katowice. Cerca de 200 floretistas femeninas de todo el mundo participaron en la competición individual, mientras que Francia se llevó el oro en la competición por equipos, en la que participaron 20 países. La competición tuvo lugar en el Spodek Hall de Katowice.  Deriglazova se impuso a la alemana Leonie Ebert en el combate final de la competición individual de florete femenino y se llevó la medalla de oro con una puntuación final de 13-9. Ebert superó a la estadounidense Lee Kiefer en la semifinal, por 15-12, mientras que Deriglazova derrotó a la bicampeona del mundo italiana Arianna Errigo, por 15-10.",
    "mobileHtml": "\n      <p><b>FLORETE FEMENINO<br>KATOWICE, POLONIA<br>13 DE ENERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg24-katowice.jpg\">\n      <p>La bicampeona del mundo y medallista de oro ol\xEDmpica rusa Inna Deriglazova ha conseguido la medalla de oro en la Copa del Mundo de florete femenino en Katowice. Cerca de 200 floretistas femeninas de todo el mundo participaron en la competici\xF3n individual, mientras que Francia se llev\xF3 el oro en la competici\xF3n por equipos, en la que participaron 20 pa\xEDses. La competici\xF3n tuvo lugar en el Spodek Hall de Katowice.</p>\n      <p>Deriglazova se impuso a la alemana Leonie Ebert en el combate final de la competici\xF3n individual de florete femenino y se llev\xF3 la medalla de oro con una puntuaci\xF3n final de 13-9. Ebert super\xF3 a la estadounidense Lee Kiefer en la semifinal, por 15-12, mientras que Deriglazova derrot\xF3 a la bicampeona del mundo italiana Arianna Errigo, por 15-10.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 25-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=POL&calendar_models_CalendarsCompetition%5BDateBegin%5D=2019-01-01&calendar_models_CalendarsCompetition%5BDateEnd%5D=2019-01-22\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:60px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax()\n          pg25Anim\n            .fromTo(cOf(\"25-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg25Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE FEMENINO 7/21  En la competición por equipos de florete femenino, Francia superó a EE.UU. en la ronda final, por 45-26 y se llevó la medalla de oro. En dos reñidos combates de semifinales, Estados Unidos venció a Rusia, por 45-43, mientras que Francia venció a Italia, por 45-44. La medalla de bronce fue para Italia, por 45-38. Las ocho finalistas de la Copa del Mundo de florete femenino de Katowice fueron Inna Deriglazova (RUS, oro), Leonie Ebert (GER, plata), Arianna Errigo (ITA, bronce), Lee Kiefer (USA, bronce), Pauline Ranvier (FRA), Larisa Korobeynikova (RUS), Anastasiia Ivanova (RUS) y Francesca Palumbo (ITA). Los ocho países mejor clasificados en la competición de florete femenino fueron Francia (oro), Estados Unidos (plata), Italia (bronce), Rusia, Alemania, Canadá, Polonia y Corea.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA",
    "mobileHtml": "\n      <p>En la competici\xF3n por equipos de florete femenino, Francia super\xF3 a EE.UU. en la ronda final, por 45-26 y se llev\xF3 la medalla de oro. En dos re\xF1idos combates de semifinales, Estados Unidos venci\xF3 a Rusia, por 45-43, mientras que Francia venci\xF3 a Italia, por 45-44. La medalla de bronce fue para Italia, por 45-38.</p>\n      <p>Las ocho finalistas de la Copa del Mundo de florete femenino de Katowice fueron Inna Deriglazova (RUS, oro), Leonie Ebert (GER, plata), Arianna Errigo (ITA, bronce), Lee Kiefer (USA, bronce), Pauline Ranvier (FRA), Larisa Korobeynikova (RUS), Anastasiia Ivanova (RUS) y Francesca Palumbo (ITA).</p>\n      <p>Los ocho pa\xEDses mejor clasificados en la competici\xF3n de florete femenino fueron Francia (oro), Estados Unidos (plata), Italia (bronce), Rusia, Alemania, Canad\xE1, Polonia y Corea.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 26-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax()\n          pg26Anim\n            .fromTo(cOf(\"26-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA FEMENINA 8/21  ESPADA FEMENINA LA HABANA, CUBA 13 DE ENERO DE 2019  La esgrimista de Hong Kong Man Wai Vivian Kong consiguió la medalla de oro individual en la Copa del Mundo de espada femenina de La Habana, tras superar a más de 150 competidoras. Estonia se llevó la medalla de oro de la competición por equipos de espada femenina, en la que participaron 20 países. La competición se celebró en el Coliseo de la Ciudad Deportiva de La Habana.  Kong se enfrentó a la francesa Auriane Mallo en la ronda final y ganó el oro con una puntuación de 15-8. Mallo derrotó a la coreana Young Mi Kang en la semifinal, por 15-9, mientras que Kong se impuso a la italiana Nicol Foietta, por 15-7. Foietta había derrotado a su compañera de equipo y actual campeona del mundo, Mara Navarria, en los cuartos de final, por 15-9.",
    "mobileHtml": "\n      <p><b>ESPADA FEMENINA<br>LA HABANA, CUBA<br>13 DE ENERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg26-havana.jpg\">\n      <p>La esgrimista de Hong Kong Man Wai Vivian Kong consigui\xF3 la medalla de oro individual en la Copa del Mundo de espada femenina de La Habana, tras superar a m\xE1s de 150 competidoras. Estonia se llev\xF3 la medalla de oro de la competici\xF3n por equipos de espada femenina, en la que participaron 20 pa\xEDses. La competici\xF3n se celebr\xF3 en el Coliseo de la Ciudad Deportiva de La Habana.</p>\n      <p>Kong se enfrent\xF3 a la francesa Auriane Mallo en la ronda final y gan\xF3 el oro con una puntuaci\xF3n de 15-8. Mallo derrot\xF3 a la coreana Young Mi Kang en la semifinal, por 15-9, mientras que Kong se impuso a la italiana Nicol Foietta, por 15-7. Foietta hab\xEDa derrotado a su compa\xF1era de equipo y actual campeona del mundo, Mara Navarria, en los cuartos de final, por 15-9.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 27-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=CUB&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:60px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax()\n          pg27Anim\n            .fromTo(cOf(\"27-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA FEMENINA 9/21  En la competición de espada femenina por equipos, Estonia venció a Polonia en la final, por 34-33. En la semifinal, Polonia vivió otro combate reñido, en el que venció a Rusia por 44-43, mientras que Estonia superó a China, por 45-23. Rusia se llevó la medalla de bronce tras ganar contra China, por 42-35. Las ocho finalistas de la Copa del Mundo de espada femenina de La Habana fueron Man Wai Vivian Kong (HKG, oro), Auriane Mallo (FRA, plata), Nicol Foietta (ITA, bronce), Young Mi Kang  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  (KOR, bronce), Mara Navarria, Violetta Kolobova (RUS), Federica Isola (ITA) y Josephine Jacques Andres Coquin (FRA). Los ocho países mejor clasificados en la competición de espada femenina por equipos fueron Estonia (oro), Polonia (plata), Rusia (bronce), China, Italia, Estados Unidos, Corea y Hungría.",
    "mobileHtml": "\n      <p>En la competici\xF3n de espada femenina por equipos, Estonia venci\xF3 a Polonia en la final, por 34-33. En la semifinal, Polonia vivi\xF3 otro combate re\xF1ido, en el que venci\xF3 a Rusia por 44-43, mientras que Estonia super\xF3 a China, por 45-23. Rusia se llev\xF3 la medalla de bronce tras ganar contra China, por 42-35.</p>\n      <p>Las ocho finalistas de la Copa del Mundo de espada femenina de La Habana fueron Man Wai Vivian Kong (HKG, oro), Auriane Mallo (FRA, plata), Nicol Foietta (ITA, bronce), Young Mi Kang (KOR, bronce), Mara Navarria, Violetta Kolobova (RUS), Federica Isola (ITA) y Josephine Jacques Andres Coquin (FRA).</p>\n      <p>Los ocho pa\xEDses mejor clasificados en la competici\xF3n de espada femenina por equipos fueron Estonia (oro), Polonia (plata), Rusia (bronce), China, Italia, Estados Unidos, Corea y Hungr\xEDa.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 28-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax()\n          pg28Anim\n            .fromTo(cOf(\"28-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE FEMENINO 10/21  FLORETE FEMENINO SAINT MAUR, FRANCIA 27 DE ENERO DE 2019  La bicampeona del mundo rusa y la medallista de oro olímpica Inna Deriglazova consiguió la medalla de oro en la Copa del Mundo de florete femenino de Saint Maur, mientras que el equipo francés también ganó el oro en la competición por equipos. La competición, que se celebró en el Centro Deportivo Pierre Brossolette de Saint Maur, contó con la participación de más de 195 floretistas femeninas internacionales y 23 equipos.  Deriglazova se enfrentó a la campeona del mundo italiana Alice Volpi en la final de la competición individual y ganó con una puntuación de 1512. Volpi superó a su compañera de equipo Francesca Palumbo en la semifinal, por 15-11, y Deriglazova venció a la francesa Ysaora Thibus, por 15-12. En la competición de florete femenino por equipos, Francia y Rusia se enfrentaron en la final y las francesas se llevaron el oro, por 41-39. Rusia superó a Italia en la semifinal, por 45-38,",
    "mobileHtml": "\n      <p><b>FLORETE FEMENINO<br>SAINT MAUR, FRANCIA<br>27 DE ENERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg28-st-maur.jpg\">\n      <p>La bicampeona del mundo rusa y la medallista de oro ol\xEDmpica Inna Deriglazova consigui\xF3 la medalla de oro en la Copa del Mundo de florete femenino de Saint Maur, mientras que el equipo franc\xE9s tambi\xE9n gan\xF3 el oro en la competici\xF3n por equipos. La competici\xF3n, que se celebr\xF3 en el Centro Deportivo Pierre Brossolette de Saint Maur, cont\xF3 con la participaci\xF3n de m\xE1s de 195 floretistas femeninas internacionales y 23 equipos.</p>\n      <p>Deriglazova se enfrent\xF3 a la campeona del mundo italiana Alice Volpi en la final de la competici\xF3n individual y gan\xF3 con una puntuaci\xF3n de 15-12. Volpi super\xF3 a su compa\xF1era de equipo Francesca Palumbo en la semifinal, por 15-11, y Deriglazova venci\xF3 a la francesa Ysaora Thibus, por 15-12.</p>\n      <p>En la competici\xF3n de florete femenino por equipos, Francia y Rusia se enfrentaron en la final y las francesas se llevaron el oro, por 41-39. Rusia super\xF3 a Italia en la semifinal, por 45-38, mientras que Francia venci\xF3 a EE. UU. por un solo punto, por 45-44. Italia se impuso en la ronda por el bronce y derrot\xF3 a EE. UU., por 45-37.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 29-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=F&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=FRA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:60px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax()\n          pg29Anim\n            .fromTo(cOf(\"29-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE FEMENINO 11/21  mientras que Francia venció a EE. UU. por un solo punto, por 45-44. Italia se impuso en la ronda por el bronce y derrotó a EE. UU., por 45-37. Las ocho finalistas individuales de la Copa del Mundo de florete femenino en Saint Maur fueron Inna Deriglazova (RUS, oro), Alice Volpi (ITA, plata), Francesca Palumbo (ITA, bronce), Ysaora Thibus (FRA, bronce), Svetlana Tripapina (RUS), Adelina Zagidullina (RUS), Jessica Zi Jia Guo (CAN) y Anita Blaze (FRA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  Los ocho países finalistas en la competición de florete femenino por equipos fueron Francia (oro), Rusia (plata), Italia (bronce), Estados Unidos, Alemania, Polonia, Japón y Corea.",
    "mobileHtml": "\n      <p>Las ocho finalistas individuales de la Copa del Mundo de florete femenino en Saint Maur fueron Inna Deriglazova (RUS, oro), Alice Volpi (ITA, plata), Francesca Palumbo (ITA, bronce), Ysaora Thibus (FRA, bronce), Svetlana Tripapina (RUS), Adelina Zagidullina (RUS), Jessica Zi Jia Guo (CAN) y Anita Blaze (FRA).</p>\n      <p>Los ocho pa\xEDses finalistas en la competici\xF3n de florete femenino por equipos fueron Francia (oro), Rusia (plata), Italia (bronce), Estados Unidos, Alemania, Polonia, Jap\xF3n y Corea.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:71px;right:320px;width:830px; height:48px;\">\n          <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.blue-gauntlet.com\" target=\"_blank\">\n        <img src=\"/109/es/static/_mobile/30.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:326px;right:361px;width:169px; height:48px;\">\n          <a href=\"https://www.favero.com/es/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.favero.com\" target=\"_blank\">\n        <img src=\"/109/es/static/_mobile/31.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 32-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax()\n          pg32Anim\n            .fromTo(cOf(\"32-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE MASCULINO 12/21  FLORETE MASCULINO TOKIO, JAPÓN 27 DE ENERO DE 2019  El británico Richard Kruse se llevó la medalla de oro en la Copa del Mundo de florete masculino del Trofeo Príncipe Takamado en Tokio, mientras que Italia también ganó el oro en la competición por equipos masculina. La competición, que se celebró en el Minato City Sports Center de Tokio, contó con la participación de más de 195 floretistas internacionales masculinos y 21 equipos. Kruse se enfrentó al estadounidense Race Imboden en la final y venció con un marcador de 15-9. Ambos esgrimistas se enfrentaron a  campeones italianos en las semifinales, en las que Imboden venció al campeón del mundo Alessio Foconi, por 15-6, y Kruse al medallista de oro olímpico Daniele Garozzo, por 15-10. Cabe destacar que el cuatro veces campeón del mundo de esgrima alemán Peter Joppich fue derrotado por Imboden en cuartos de final, por 15-7. En la competición de florete por equipos, Italia se enfrentó a Estados Unidos en la final y se llevó la medalla de oro por dos puntos, por 4543. Los estadounidenses derrotaron a Corea",
    "mobileHtml": "\n      <p><b>FLORETE MASCULINO<br>TOKIO, JAP\xD3N<br>27 DE ENERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg32-tokyo.jpg\">\n      <p>El brit\xE1nico Richard Kruse se llev\xF3 la medalla de oro en la Copa del Mundo de florete masculino del Trofeo Pr\xEDncipe Takamado en Tokio, mientras que Italia tambi\xE9n gan\xF3 el oro en la competici\xF3n por equipos masculina. La competici\xF3n, que se celebr\xF3 en el Minato City Sports Center de Tokio, cont\xF3 con la participaci\xF3n de m\xE1s de 195 floretistas internacionales masculinos y 21 equipos.</p>\n      <p>Kruse se enfrent\xF3 al estadounidense Race Imboden en la final y venci\xF3 con un marcador de 15-9. Ambos esgrimistas se enfrentaron a campeones italianos en las semifinales, en las que Imboden venci\xF3 al campe\xF3n del mundo Alessio Foconi, por 15-6, y Kruse al medallista de oro ol\xEDmpico Daniele Garozzo, por 15-10. Cabe destacar que el cuatro veces campe\xF3n del mundo de esgrima alem\xE1n Peter Joppich fue derrotado por Imboden en cuartos de final, por 15-7.</p>\n      <p>En la competici\xF3n de florete por equipos, Italia se enfrent\xF3 a Estados Unidos en la final y se llev\xF3 la medalla de oro por dos puntos, por 45-43. Los estadounidenses derrotaron a Corea en la semifinal, por 45-32, mientras que Italia venci\xF3 a Rusia, por 45-29. La medalla de bronce fue para Corea tras derrotar a Rusia, por 45-29.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 33-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=F&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=JPN&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:61px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax()\n          pg33Anim\n            .fromTo(cOf(\"33-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg33Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO FLORETE MASCULINO 13/21  en la semifinal, por 45-32, mientras que Italia venció a Rusia, por 45-29. La medalla de bronce fue para Corea tras derrotar a Rusia, por 45-29. Los ocho finalistas de florete individual masculino en la Copa del Mundo de florete masculino del Trofeo Príncipe Takamado fueron Richard Kruse (GBR, oro), Race Imboden (USA, plata), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA, bronce), Jun Heo (KOR), Peter Joppich (GER), Timur Arslanov (RUS) y Miles Chamley-Watson (USA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Los ocho países finalistas en la competición de florete masculino por equipos fueron Italia (oro), Estados Unidos (plata), Corea (bronce), Rusia, Japón, Francia, Polonia y China.",
    "mobileHtml": "\n      <p>Los ocho finalistas de florete individual masculino en la Copa del Mundo de florete masculino del Trofeo Pr\xEDncipe Takamado fueron Richard Kruse (GBR, oro), Race Imboden (USA, plata), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA, bronce), Jun Heo (KOR), Peter Joppich (GER), Timur Arslanov (RUS) y Miles Chamley-Watson (USA).</p>\n      <p>Los ocho pa\xEDses finalistas en la competici\xF3n de florete masculino por equipos fueron Italia (oro), Estados Unidos (plata), Corea (bronce), Rusia, Jap\xF3n, Francia, Polonia y China.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 34-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax()\n          pg34Anim\n            .fromTo(cOf(\"34-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO SABLE FEMENINO 14/21  SABLE FEMENINO SALT LAKE CITY, Utah, EE. UU. 27 DE ENERO DE 2019  Francia se llevó las dos medallas de oro en la Copa del Mundo de sable feminino Absolute Fencing Gear de la FIE de 2019, tanto en la competición individual como por equipos. Celebrada en el Salt Palace Convention Center de Salt Lake City, la competición atrajo a más de 160 esgrimistas femeninas internacionales y a equipos de 18 países. La medalla de oro de sable femenino individual fue para la francesa Cecilia Berder, que venció a la húngara Anna Marton por un solo toque,  por 15-14. Marton superó a la italiana Irene Vecchi en las semifinales, por 15-9, mientras que Berder derrotó a la bicampeona del mundo rusa, Sofia Velikaya, por 15-7. Cabe destacar que la campeona olímpica coreana Jiyeon Kim quedó eliminada en cuartos de final frente a Velikaya, por 15-12, y la vigente campeona del mundo Sofia Pozdniakova fue derrotada por Berder en la misma ronda, por 15-11. En la competición por equipos de sable femenino, Francia venció a Hungría en la ronda",
    "mobileHtml": "\n      <p><b>SABLE FEMENINO<br>SALT LAKE CITY, UTAH, EE. UU.<br>27 DE ENERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg34-salt-lake-city.jpg\">\n      <p>Francia se llev\xF3 las dos medallas de oro en la Copa del Mundo de sable femenino Absolute Fencing Gear de la FIE de 2019, tanto en la competici\xF3n individual como por equipos. Celebrada en el Salt Palace Convention Center de Salt Lake City, la competici\xF3n atrajo a m\xE1s de 160 esgrimistas femeninas internacionales y a equipos de 18 pa\xEDses.</p>\n      <p>La medalla de oro de sable femenino individual fue para la francesa Cecilia Berder, que venci\xF3 a la h\xFAngara Anna Marton por un solo toque, por 15-14. Marton super\xF3 a la italiana Irene Vecchi en las semifinales, por 15-9, mientras que Berder derrot\xF3 a la bicampeona del mundo rusa, Sofia Velikaya, por 15-7. Cabe destacar que la campeona ol\xEDmpica coreana Jiyeon Kim qued\xF3 eliminada en cuartos de final frente a Velikaya, por 15-12, y la vigente campeona del mundo Sofia Pozdniakova fue derrotada por Berder en la misma ronda, por 15-11.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 35-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=S&calendar_models_CalendarsCompetition%5BGenderId%5D=F&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=USA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:60px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax()\n          pg35Anim\n            .fromTo(cOf(\"35-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg35Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO SABLE FEMENINO 15/21  final, por 45-42. Hungría había superado a Italia en las semifinales, por 45-37, y Francia se impuso a China con el mismo resultado, 4537. La medalla de bronce fue para Italia tras derrotar a China, por 45-40. Las ocho finalistas de sable individual femenino en la Copa del Mundo de sable femenino Absolute Fencing Gear de la FIE de 2019 fueron Cecilia Berder (FRA, oro), Anna Marton (HUN, plata), Irene Vecchi (ITA, bronce), Sofya Velikaya  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  (RUS, bronce), Sofia Pozdniakova (RUS), Jiyeon Kim (KOR), Liza Pusztai (HUN) y Theodora Gkountoura (GRE). Los ocho equipos finalistas de sable femenino fueron Francia (oro), Hungría (plata), Italia (bronce), China, Estados Unidos, Corea, Ucrania y Rusia.",
    "mobileHtml": "\n      <p>En la competici\xF3n por equipos de sable femenino, Francia venci\xF3 a Hungr\xEDa en la ronda final, por 45-42. Hungr\xEDa hab\xEDa superado a Italia en las semifinales, por 45-37, y Francia se impuso a China con el mismo resultado, 45-37. La medalla de bronce fue para Italia tras derrotar a China, por 45-40.</p>\n      <p>Las ocho finalistas de sable individual femenino en la Copa del Mundo de sable femenino Absolute Fencing Gear de la FIE de 2019 fueron Cecilia Berder (FRA, oro), Anna Marton (HUN, plata), Irene Vecchi (ITA, bronce), Sofya Velikaya (RUS, bronce), Sofia Pozdniakova (RUS), Jiyeon Kim (KOR), Liza Pusztai (HUN) y Theodora Gkountoura (GRE).</p>\n      <p>Los ocho equipos finalistas de sable femenino fueron Francia (oro), Hungr\xEDa (plata), Italia (bronce), China, Estados Unidos, Corea, Ucrania y Rusia.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 36-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax()\n          pg36Anim\n            .fromTo(cOf(\"36-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO SABLE MASCULINO 16/21  SABLE MASCULINO VARSOVIA, POLONIA 3 DE FEBRERO DE 2019  El tirador estadounidense Eli Dershwitz ganó la medalla de oro individual en la 64ª Copa del mundo de Sable masculino “Sabre de Wolodyjowski” de Varsovia, e Italia ganó la medalla de oro de la prueba masculina por equipos. En la competencia, que se celebró en la sede del Comité Olímpico Polaco en Varsovia, participaron unos 220 tiradores de sable masculino y 27 equipos internacionales. Dershwitz se enfrentó al italiano Luca Curatoli en la final, ganando con un resultado de 15-9.  Curatoli derrotó por un escaso margen al alemán Max Hartung en la semifinal, por 15-14, mientras que Dershwitz obtuvo una victoria similar sobre el coreano Sanguk Oh, por 15-14. En particular, Curatoli tuvo una reñida victoria en cuartos de final, por 15-14, frente al campeón mundial ruso Veniamin Reshetnikov. La final de sable masculino por equipos también fue muy reñida, e Italia venció a Francia por la medalla de oro con un solo toque, por 4544. Francia venció a Rusia en la semifinal, por",
    "mobileHtml": "\n      <p><b>SABLE MASCULINO<br>VARSOVIA, POLONIA<br>3 DE FEBRERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg36-warsaw.jpg\">\n      <p>El tirador estadounidense Eli Dershwitz gan\xF3 la medalla de oro individual en la 64\xAA Copa del mundo de Sable masculino \xABSabre de Wolodyjowski\xBB de Varsovia, e Italia gan\xF3 la medalla de oro de la prueba masculina por equipos. En la competencia, que se celebr\xF3 en la sede del Comit\xE9 Ol\xEDmpico Polaco en Varsovia, participaron unos 220 tiradores de sable masculino y 27 equipos internacionales.</p>\n      <p>Dershwitz se enfrent\xF3 al italiano Luca Curatoli en la final, ganando con un resultado de 15-9. Curatoli derrot\xF3 por un escaso margen al alem\xE1n Max Hartung en la semifinal, por 15-14, mientras que Dershwitz obtuvo una victoria similar sobre el coreano Sanguk Oh, por 15-14. En particular, Curatoli tuvo una re\xF1ida victoria en cuartos de final, por 15-14, frente al campe\xF3n mundial ruso Veniamin Reshetnikov.</p>\n      <p>La final de sable masculino por equipos tambi\xE9n fue muy re\xF1ida, e Italia venci\xF3 a Francia por la medalla de oro con un solo toque, por 45-44. Francia venci\xF3 a Rusia en la semifinal, por 45-38, mientras que Italia derrot\xF3 a Hungr\xEDa, por 45-37. Rusia se llev\xF3 la medalla de bronce frente a Hungr\xEDa, por 45-36.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 37-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=S&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=POL&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:61px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax()\n          pg37Anim\n            .fromTo(cOf(\"37-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO SABLE MASCULINO 17/21  45-38, mientras que Italia derrotó a Hungría, por 45-37. Rusia se llevó la medalla de bronce frente a Hungría, por 45-36. Las ocho posiciones finales en la prueba individual masculina incluyeron a Eli Dershwitz (EE. UU., oro), Luca Curatoli (ITA, plata), Max Hartung (GER, bronce), Sanguk Oh (KOR, bronce), Bongil Gu (KOR), Kamil Ibragimov (RUS), Veniamin Reshetnikov (RUS) y Jonghyun Lee (KOR). Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  En la prueba masculina por equipos, los ocho primeros clasificados fueron Italia (oro), Francia (plata), Rusia (bronce), Hungría, Corea, Rumanía, Alemania y China.",
    "mobileHtml": "\n      <p>Las ocho posiciones finales en la prueba individual masculina incluyeron a Eli Dershwitz (EE. UU., oro), Luca Curatoli (ITA, plata), Max Hartung (GER, bronce), Sanguk Oh (KOR, bronce), Bongil Gu (KOR), Kamil Ibragimov (RUS), Veniamin Reshetnikov (RUS) y Jonghyun Lee (KOR).</p>\n      <p>En la prueba masculina por equipos, los ocho primeros clasificados fueron Italia (oro), Francia (plata), Rusia (bronce), Hungr\xEDa, Corea, Ruman\xEDa, Alemania y China.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 38-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax()\n          pg38Anim\n            .fromTo(cOf(\"38-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA MASCULINA 18/21  ESPADA MASCULINA VANCOUVER, B.C., CANADÁ 10 DE FEBRERO DE 2019  El japonés Koki Kano se llevó el oro en espada individual masculina en la Copa del mundo Coupe du Monde Peter Bakonyi en Richmond, Columbia Británica, y Rusia anotó el oro en la prueba de espada masculina por equipos. La prueba atrajo a unos 200 espadistas y equipos internacionales masculinos de 23 países, y tuvo lugar en el Óvalo Olímpico de Richmond, una sede de los Juegos Olímpicos de Invierno de Vancouver. Kano se enfrentó al italiano Enrico Garozzo en el encuentro final individual de espada masculina, ganando por 15-7. En la ronda de semifinales, Garozzo venció al estadounidense Jacob Hoyle por un solo toque, por 15-14, y Kano superó al francés Alexandre Bardenet, por 15-8. En",
    "mobileHtml": "\n      <p><b>ESPADA MASCULINA<br>VANCOUVER, B.C., CANAD\xC1<br>10 DE FEBRERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg38-vancouver.jpg\">\n      <p>El japon\xE9s Koki Kano se llev\xF3 el oro en espada individual masculina en la Copa del mundo Coupe du Monde Peter Bakonyi en Richmond, Columbia Brit\xE1nica, y Rusia anot\xF3 el oro en la prueba de espada masculina por equipos. La prueba atrajo a unos 200 espadistas y equipos internacionales masculinos de 23 pa\xEDses, y tuvo lugar en el \xD3valo Ol\xEDmpico de Richmond, una sede de los Juegos Ol\xEDmpicos de Invierno de Vancouver.</p>\n      <p>Kano se enfrent\xF3 al italiano Enrico Garozzo en el encuentro final individual de espada masculina, ganando por 15-7. En la ronda de semifinales, Garozzo venci\xF3 al estadounidense Jacob Hoyle por un solo toque, por 15-14, y Kano super\xF3 al franc\xE9s Alexandre Bardenet, por 15-8. En cuartos de final, el venezolano Rub\xE9n Limardo Gasc\xF3n, medalla de oro ol\xEDmpica, tambi\xE9n fue eliminado por Garozzo con un solo toque, por 15-14. Cabe destacar que el medallista de oro ol\xEDmpico coreano Sangyoung Park fue eliminado en la ronda 16 por el franc\xE9s Romain Cannone, por 15-11, quien fue derrotado por Hoyle en cuartos de final por 15-13.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 39-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=E&calendar_models_CalendarsCompetition%5BGenderId%5D=M&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=CAN&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:61px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax()\n          pg39Anim\n            .fromTo(cOf(\"39-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA MASCULINA 19/21  cuartos de final, el venezolano Rubén Limardo Gascón, medalla de oro olímpica, también fue eliminado por Garozzo con un solo toque, por 15-14. Cabe destacar que el medallista de oro olímpico coreano Sangyoung Park fue eliminado en la ronda 16 por el francés Romain Cannone, por 15-11, quien fue derrotado por Hoyle en cuartos de final por 15-13. Rusia se enfrentó a Israel en la ronda final de la prueba de espada masculina por equipos con un resultado de 45-36. Israel había derrotado a Dinamarca en la ronda de semifinales, por 4542, y Rusia venció a Francia por 45-33. Francia se llevó la medalla de bronce frente a Dinamarca, por 45-32. Los ocho primeros finalistas individuales de la Copa del mundo de Vancouver fueron Koki Kano (JPN, oro), Enrico Garozzo (ITA, plata), Alexandre Bardenet (FRA, bronce), Jacob Hoyle (EE. UU., bronce), Rubén Limardo Gascón (VEN), Dmitriy Alexanin (KAZ), Romain Cannone (FRA) y Federico Vismara (ITA).  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Entre los ocho primeros ganadores de la prueba de espada masculina por equipos se encuentran Rusia (oro), Israel (plata), Francia (bronce), Dinamarca, EE. UU., Ucrania, Alemania y la República Checa.",
    "mobileHtml": "\n      <p>Rusia se enfrent\xF3 a Israel en la ronda final de la prueba de espada masculina por equipos con un resultado de 45-36. Israel hab\xEDa derrotado a Dinamarca en la ronda de semifinales, por 45-42, y Rusia venci\xF3 a Francia por 45-33. Francia se llev\xF3 la medalla de bronce frente a Dinamarca, por 45-32.</p>\n      <p>Los ocho primeros finalistas individuales de la Copa del mundo de Vancouver fueron Koki Kano (JPN, oro), Enrico Garozzo (ITA, plata), Alexandre Bardenet (FRA, bronce), Jacob Hoyle (EE. UU., bronce), Rub\xE9n Limardo Gasc\xF3n (VEN), Dmitriy Alexanin (KAZ), Romain Cannone (FRA) y Federico Vismara (ITA).</p>\n      <p>Entre los ocho primeros ganadores de la prueba de espada masculina por equipos se encuentran Rusia (oro), Israel (plata), Francia (bronce), Dinamarca, EE. UU., Ucrania, Alemania y la Rep\xFAblica Checa.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 40-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax()\n          pg40Anim\n            .fromTo(cOf(\"40-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA FEMENINA 20/21  ESPADA FEMENINA BARCELONA, ESPAÑA 10 DE FEBRERO DE 2019  La hongkonesa Man Wai Vivian Kong ganó su segunda copa del mundo de la FIE de manera consecutiva, llevándose el oro en la 43ª edición de la Copa del mundo de Espada femenina “Ciutat de Barcelona”. El equipo polaco se llevó la medalla de oro en espada por equipos. Más de 280 mujeres espadistas y de 29 equipos participaron en la competencia, que tuvo lugar  en el Institut Nacional d’Educació Física de Catalunya (INEFC), sede de los Juegos Olímpicos y Paralímpicos de Barcelona de 1992. Kong se enfrentó a la coreana Hyein Lee en el encuentro final y venció con un resultado de 15-12. Lee venció a la polaca Aleksandra Zamachowska en la semifinal, por 15-7, mientras",
    "mobileHtml": "\n      <p><b>ESPADA FEMENINA<br>BARCELONA, ESPA\xD1A<br>10 DE FEBRERO DE 2019<br></b></p>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg40-barcelona.jpg\">\n      <p>La hongkonesa Man Wai Vivian Kong gan\xF3 su segunda copa del mundo de la FIE de manera consecutiva, llev\xE1ndose el oro en la 43\xAA edici\xF3n de la Copa del mundo de Espada femenina \xABCiutat de Barcelona\xBB. El equipo polaco se llev\xF3 la medalla de oro en espada por equipos. M\xE1s de 280 mujeres espadistas y de 29 equipos participaron en la competencia, que tuvo lugar en el Institut Nacional d\u2019Educaci\xF3 F\xEDsica de Catalunya (INEFC), sede de los Juegos Ol\xEDmpicos y Paral\xEDmpicos de Barcelona de 1992.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 41-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/10-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/9-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/9-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=E&calendar_models_CalendarsCompetition%5BGenderId%5D=F&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=A&calendar_models_CalendarsCompetition%5BCPYear%5D=2019&calendar_models_CalendarsCompetition%5BFedId%5D=ESP&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:892px;left:60px\" src=\"/109/es/static/_content/10-tap-trophy.png\">\n      </a>\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax()\n          pg41Anim\n            .fromTo(cOf(\"41-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "COPA DEL MUNDO ESPADA FEMENINA 21/21  que Kong superó a la estonia Kristina Kuusk, por 15-11. Kong también ganó la copa del mundo de espada femenina el mes pasado en La Habana, Cuba. En la prueba de espada femenina por equipos, Polonia venció a Rusia en la ronda final, por 45-40. Rusia venció a China en semifinales, por 42-36, y Polonia venció a Francia por 36-29. La medalla de bronce fue para China tras derrotar a Francia por 45-38.  Entre las ocho primeras finalistas individuales de la Copa del mundo de Espada femenina de Barcelona se encuentran Man Wai Vivian Kong (HKG, oro), Hyein Lee (KOR, plata), Kristina Kuusk (EST, bronce), Aleksandra Zamachowska (POL, bronce), Kelley Hurley (EE. UU.), Dorina Budai (HUN), Sera Song (KOR) e Isis Washington (EE. UU.). Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  Los ocho países finalistas en la prueba de espada femenina por equipos fueron Polonia (oro), Rusia (plata), China (bronce), Francia, Hungría, EE. UU., Rumanía e Italia. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p>Kong se enfrent\xF3 a la coreana Hyein Lee en el encuentro final y venci\xF3 con un resultado de 15-12. Lee venci\xF3 a la polaca Aleksandra Zamachowska en la semifinal, por 15-7, mientras que Kong super\xF3 a la estonia Kristina Kuusk, por 15-11. Kong tambi\xE9n gan\xF3 la copa del mundo de espada femenina el mes pasado en La Habana, Cuba.</p>\n      <p>En la prueba de espada femenina por equipos, Polonia venci\xF3 a Rusia en la ronda final, por 45-40. Rusia venci\xF3 a China en semifinales, por 42-36, y Polonia venci\xF3 a Francia por 36-29. La medalla de bronce fue para China tras derrotar a Francia por 45-38.</p>\n      <p>Entre las ocho primeras finalistas individuales de la Copa del mundo de Espada femenina de Barcelona se encuentran Man Wai Vivian Kong (HKG, oro), Hyein Lee (KOR, plata), Kristina Kuusk (EST, bronce), Aleksandra Zamachowska (POL, bronce), Kelley Hurley (EE. UU.), Dorina Budai (HUN), Sera Song (KOR) e Isis Washington (EE. UU.).</p>\n      <p>Los ocho pa\xEDses finalistas en la prueba de espada femenina por equipos fueron Polonia (oro), Rusia (plata), China (bronce), Francia, Hungr\xEDa, EE. UU., Ruman\xEDa e Italia.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:124px;right:459px;width:310px; height:25px;\">\n          <a href=\"http://www.jiangfencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:98px;right:459px;width:310px; height:25px;\">\n          <a href=\"mailto:jason@jiangfencing.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <img src=\"/109/es/static/_mobile/42.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:193px;right:633px;width:180px; height:30px;\">\n          <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:198px;right:844px;width:30px; height:30px;\">\n          <a href=\"http://www.facebook.com/UhlmannFechtsport\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:198px;right:813px;width:30px; height:30px;\">\n          <a href=\"http://www.instagram.com/Uhlmann.Fencing\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\">\n          <img src=\"/109/es/static/_mobile/43.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 44-title\" style=\"top:75px;left:80px\" src=\"/109/es/static/_content/44-title.png\">\n\n      <img class=\"halfScale 44-line\" style=\"top:317px;left:86px\" src=\"/109/es/static/_content/44-line.png\">\n\n      <img class=\"halfScale 44-sub\" style=\"top:314px;left:122px\" src=\"/109/es/static/_content/44-sub.png\">\n\n      <img class=\"halfScale pointer 44-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/44-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax()\n          pg44Anim\n            .fromTo(cOf(\"44-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"44-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"44-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"44-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg44Anim.stop()\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <h2>CAMPEONATOS DEL MUNDO DE ESGRIMA JUVENIL Y CADETE DE 2019 EN TORUN</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg44-torun.jpg\">\n      <p><b>TORUN, POLONIA <br>6 AL 14 DE ABRIL DE 2019<br></b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 45-arrow\" style=\"top:845px;left:1407px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/44-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/45-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/45-social-fb.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax()\n          pg45Anim\n            .fromTo(cOf(\"45-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg45Anim.stop()\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <p><b>Los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun est\xE1n preparados para recibir a varios miles de visitantes en Polonia en abril, incluidos los tiradores y sus entrenadores, aficionados y simpatizantes.</b></p>\n      <p>Los Campeonatos re\xFAnen a atletas adolescentes de docenas de pa\xEDses para competir en 18 pruebas: De las dos categor\xEDas de edad de los j\xF3venes que compiten, hombres y mujeres, cadetes y juveniles, los cadetes m\xE1s j\xF3venes participar\xE1n en seis pruebas individuales con las tres armas (florete, espada y sable), y los juveniles tambi\xE9n participar\xE1n en seis pruebas individuales y en seis torneos por equipos. Todos ellos se celebrar\xE1n en el Arena Sports Hall de Torun durante nueve d\xEDas, del 6 al 14 de abril.</p>\n      <p>Los Campeonatos del Mundo de Esgrima Juvenil y Cadete del a\xF1o pasado se celebraron en Verona, Italia, donde particip\xF3 un n\xFAmero r\xE9cord de atletas. Una vez m\xE1s, este a\xF1o la FIE espera reunir cifras iguales o superiores de j\xF3venes tiradores participantes, todos dispuestos a conseguir medallas de oro, as\xED como de pasar tiempo con viejos y nuevos amigos de todo el mundo.  </p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 46-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/46-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/45-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/45-social-fb.png\">\n      </a>\n\n      <a href=\"https://www.FencingTorun2019.com\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:790px;left:57px\" src=\"/109/es/static/_content/46-tap-info.png\">\n      </a>\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax()\n          pg46Anim\n            .fromTo(cOf(\"46-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg46Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JÚNIOR Y CADETE TORUN, POLONIA 2/3  Los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2019 en Torun están preparados para recibir a varios miles de visitantes en Polonia en abril, incluidos los tiradores y sus entrenadores, aficionados y simpatizantes. Los Campeonatos reúnen a atletas adolescentes de docenas de países para competir en 18 pruebas: De las dos categorías de edad de los jóvenes que compiten, hombres y mujeres, cadetes y juveniles, los cadetes más jóvenes participarán en seis pruebas individuales con las tres armas (florete, espada y sable), y los juveniles también participarán en seis pruebas individuales y en seis torneos por equipos. Todos ellos se celebrarán en el Arena Sports Hall de Torun durante nueve días, del 6 al 14 de abril. Los Campeonatos del Mundo de Esgrima Juvenil y Cadete del año pasado se celebraron en Verona, Italia, donde participó un número récord de atletas. Una vez más, este año la FIE espera reunir cifras iguales o superiores de jóvenes tiradores participantes, todos dispuestos a conseguir medallas de oro, así como de pasar tiempo con viejos y nuevos amigos de todo el mundo.  Habrá disponibles varios programas en Torun para los atletas, incluida la oportunidad de traer su equipo de esgrima usado y de concederlo al programa de la FIE “Donate Your Fencing Gear!”, beneficiando a las federaciones y tiradores en desarrollo y desfavorecidos. Se pondrán a disposición de todos presentaciones y programas educativos sobre la lucha contra el dopaje y la protección de los atletas, así como",
    "mobileHtml": "\n      <p>Habr\xE1 disponibles varios programas en Torun para los atletas, incluida la oportunidad de traer su equipo de esgrima usado y de concederlo al programa de la FIE \xABDonate Your Fencing Gear!\xBB, beneficiando a las federaciones y tiradores en desarrollo y desfavorecidos. Se pondr\xE1n a disposici\xF3n de todos presentaciones y programas educativos sobre la lucha contra el dopaje y la protecci\xF3n de los atletas, as\xED como exposiciones en las que se presentar\xE1n numerosos vendedores de equipos y promociones.</p>\n      <p>Adem\xE1s de la esgrima, los visitantes de los Campeonatos del Mundo conocer\xE1n una ciudad hist\xF3rica, de cuento de hadas, con un patrimonio y una cultura ricos, y con muchas actividades y experiencias que ofrecer. Torun es una de las ciudades m\xE1s antiguas de Polonia y, la famosa Ciudad Medieval de Tur\xEDn, Patrimonio de la Humanidad de la UNESCO, se encuentra a poca distancia de los Campeonatos del Mundo. La ciudad tambi\xE9n es famosa por sus tartas de jengibre (desde el siglo XIV), y su colorida arquitectura g\xF3tica y su panorama nocturno se consideran una de las siete maravillas de Polonia. El famoso astr\xF3nomo Nicol\xE1s Cop\xE9rnico naci\xF3 en Torun.  </p>\n      <p>El Arena Sports Hall de Torun, sede de las pruebas, est\xE1 considerado como la \xFAnica instalaci\xF3n de este tipo en Polonia, capaz de albergar un acontecimiento tan grande como el de los Campeonatos del Mundo de Esgrima Juvenil y Cadete. Este moderno y polivalente recinto de deportes y entretenimiento se inaugur\xF3 oficialmente en agosto de 2014, con iluminaci\xF3n de \xFAltima generaci\xF3n, amenidades, suelos para pruebas y asientos. Tambi\xE9n est\xE1 habilitado para la transmisi\xF3n de televisi\xF3n y para la cobertura adecuada de los medios de comunicaci\xF3n en pruebas de clase mundial.</p>\n      <p>More information about the competition, the venue, and the city of Torun is available on the official web site, <a href=\"https://www.FencingTorun2019.com\">www.FencingTorun2019.com.</a></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:330px;right:898px;width:620px; height:54px;\">\n          <a href=\"http://www.fencewithfun.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:180px;right:964px;width:210px; height:27px;\">\n          <a href=\"http://www.fencewithfun.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:180px;right:1240px;width:220px; height:27px;\">\n          <a href=\"mailto:info@fencewithfun.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.fencewithfun.com\" target=\"_blank\">\n        <img src=\"/109/es/static/_mobile/47.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:143px;right:40px;width:720px; height:48px;\">\n          <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\">\n        <img src=\"/109/es/static/_mobile/48.jpg\">\n      </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 49-title\" style=\"top:22px;left:71px\" src=\"/109/es/static/_content/49-title.png\">\n\n      <img class=\"halfScale 49-name-1\" style=\"top:647px;left:-354px\" src=\"/109/es/static/_content/49-name-1.png\">\n      <img class=\"halfScale 49-name-2\" style=\"top:773px;left:359px\" src=\"/109/es/static/_content/49-name-2.png\">\n\n      <img class=\"halfScale pointer 49-arrow\" style=\"top:949px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/49-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax()\n          pg49Anim\n            .fromTo(cOf(\"49-title\"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)\n            .fromTo(cOf(\"49-name-1\"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1},\"-=0.2\")\n            .fromTo(cOf(\"49-name-2\"), 0.4,{x:200,opacity:0}, {x:0,opacity:1},\"-=0.1\")\n            .fromTo(cOf(\"49-arrow\"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, \"-=0.1\")\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop()\n        }\n      ",
    "searchText": "CONOZCA A LOS ATLE TAS  			 YUKA 						 UENO",
    "mobileHtml": "\n      <h2>CONOZCA A LOS ATLETAS</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg49-meet.jpg\">\n      <h4>YUKA UENO</h4>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n      <img id=\"50-next\" class=\"halfScale pointer\" style=\"top:949px;left:648px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/50-arrow.png\">\n\n      <img id=\"50-no-1\" class=\"halfScale 50-questions\" style=\"top:418px;left:728px\" src=\"/109/es/static/_content/50-1.png\">\n      <img id=\"50-no-2\" class=\"halfScale 50-questions\" style=\"top:418px;left:730px; display: none;\" src=\"/109/es/static/_content/50-2.png\">\n      <img id=\"50-no-3\" class=\"halfScale 50-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/109/es/static/_content/50-3.png\">\n      <img id=\"50-no-4\" class=\"halfScale 50-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/109/es/static/_content/50-4.png\">\n      <img id=\"50-no-5\" class=\"halfScale 50-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/109/es/static/_content/50-5.png\">\n      <img id=\"50-no-6\" class=\"halfScale 50-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/109/es/static/_content/50-6.png\">\n      <img id=\"50-no-7\" class=\"halfScale 50-questions\" style=\"top:418px;left:728px; display: none;\" src=\"/109/es/static/_content/50-7.png\">\n\n      <div class=\"addContentLink\" style=\"top: 443px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('50-no-1')\"></div>\n      <div class=\"addContentLink\" style=\"top: 538px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('50-no-2')\"></div>\n      <div class=\"addContentLink\" style=\"top: 629px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('50-no-3')\"></div>\n      <div class=\"addContentLink\" style=\"top: 722px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('50-no-4')\"></div>\n      <div class=\"addContentLink\" style=\"top: 813px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('50-no-5')\"></div>\n      <div class=\"addContentLink\" style=\"top: 907px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('50-no-6')\"></div>\n      <div class=\"addContentLink\" style=\"top: 1000px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('50-no-7')\"></div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg50Anim = new TimelineMax()\n        pg50Anim.fromTo(idOf(\"50-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)\n      }\n\n      function swapQuestion(ele) {\n        var x = cOf(\"50-questions\");\n        var i;\n        for (i = 0; i < x.length; i++) {\n          x[i].style.display = 'none';\n        }\n        idOf(ele).style.display = \"\"\n      }\n\n      function onPageLeave() {\n        pg50Anim.stop()\n        removeContentLinks()\n      }\n      ",
    "searchText": "La japonesa de 17 años, Yuka Ueno, se proclamó campeona en 2018 en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de Verona en la categoría de florete femenino juvenil, y de nuevo en los Juegos Olímpicos Juveniles de Buenos Aires. Como una de las estrellas en ascenso en esgrima mundial juvenil y senior, este año defenderá su título en los Campeonatos del Mundo Juvenil y Cadete de Esgrima de Torun. ¿Cómo se convirtió en tiradora? Mis padres son tiradores, y me pareció que la esgrima era divertida; empecé cuando tenía seis años.  1 2 3 4 5 6 7",
    "mobileHtml": "\n      <p><b>La japonesa de 17 a\xF1os, Yuka Ueno, se proclam\xF3 campeona en 2018 en los Campeonatos del Mundo de Esgrima Juvenil y Cadete de Verona en la categor\xEDa de florete femenino juvenil, y de nuevo en los Juegos Ol\xEDmpicos Juveniles de Buenos Aires. Como una de las estrellas en ascenso en esgrima mundial juvenil y senior, este a\xF1o defender\xE1 su t\xEDtulo en los Campeonatos del Mundo Juvenil y Cadete de Esgrima de Torun.</b></p>\n      <br>\n\n      <p><b>\xBFC\xF3mo se convirti\xF3 en tiradora? </b></p>\n      <p>YU: Mis padres son tiradores, y me pareci\xF3 que la esgrima era divertida; empec\xE9 cuando ten\xEDa seis a\xF1os. </p>\n\n      <p><b>\xBFQu\xE9 o qui\xE9n ha representado la mayor influencia en su vida como tiradora?</b></p>\n      <p>YU: Mi padre, que me ense\xF1\xF3 esgrima muy en serio, para convertirme en una buena tiradora.</p>\n\n      <p><b>\xBFQu\xE9 prueba fue su mejor experiencia? </b></p>\n      <p>YU:  Los Campeonatos del Mundo de Esgrima Juvenil y Cadete de 2018 en Verona (donde Yuka gan\xF3 el oro).</p>\n\n      <p><b>\xBFC\xF3mo es la esgrima en Jap\xF3n? </b></p>\n      <p>YU:  Me proporcionan un apoyo muy bueno, incluidas las instalaciones de entrenamiento.</p>\n\n      <p><b>\xBFC\xF3mo fue su temporada 2017-2018?</b></p>\n      <p>YU:  Aunque algunos de los resultados fueron buenos, no me result\xF3 magn\xEDfica, ya que considero que no jugu\xE9 tan bien como se hab\xEDa esperado.</p>\n\n      <p><b>\xBFCu\xE1l es su sue\xF1o en la esgrima, su mayor ambici\xF3n?</b></p>\n      <p>YU: Ganar una medalla de oro en los Juegos Ol\xEDmpicos.</p>\n\n      <p><b>\xBFCu\xE1l es su mensaje para las aspirantes a tiradoras?  </b></p>\n      <p>YU:  \xA1Alcanza las metas que te has propuesto! </p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:391px;right:771px;width:210px; height:33px;\">\n          <a href=\"http://es.gfencing.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:391px;right:550px;width:210px; height:33px;\">\n          <a href=\"mailto:sales@gfencing.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "mobileHtml": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <img src=\"/109/es/static/_mobile/51.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 52-title\" style=\"top:234px;left:624px\" src=\"/109/es/static/_content/52-title.png\">\n\n      <img class=\"halfScale 52-line\" style=\"top:412px;left:623px\" src=\"/109/es/static/_content/52-line.png\">\n\n      <img class=\"halfScale 52-sub\" style=\"top:412px;left:658px\" src=\"/109/es/static/_content/52-sub.png\">\n\n      <img class=\"halfScale pointer 52-arrow\" style=\"top:845px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/52-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax()\n          pg52Anim\n            .fromTo(cOf(\"52-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"52-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"52-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"52-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  CLASES DE ESGRIMA CON LOS EXPERTOS BANSKO, BULGARIA 24 DE ENERO DE 2019",
    "mobileHtml": "\n      <h2>CLASES DE ESGRIMA CON LOS EXPERTOS</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg52-learning.jpg\">\n      <p><b>BANSKO, BULGARIA<br>24 DE ENERO DE 2019<br></b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 53-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/53-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/53-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/53-social-fb.png\">\n      </a>\n\n      <a href=\"http://www.internationalfencingcamp.org/\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:881px;left:59px\" src=\"/109/es/static/_content/53-tap-info.png\">\n      </a>\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax()\n          pg53Anim\n            .fromTo(cOf(\"53-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg53Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Este verano se celebrará un campamento de espada en Bansko, Bulgaria, del 29 de julio al 5 de agosto, que ofrecerá a los jóvenes atletas de todo el mundo la oportunidad de trabajar directamente con medallistas de los Juegos Olímpicos y del Campeonato del Mundo.  Pulse aquí para obtener más INFORMACIÓN  El Campamento Internacional de Esgrima está abierto a esgrimistas principiantes, de nivel intermedio y de élite, niños y niñas, de las categorías sub-12 (2010-2007), sub-15 (20062004) y sub-18 (2003-2001). En el campamento con una duración de seis días participarán Rubén Limardo-Gascón (VEN, medalla de oro olímpica, Londres 2012), Nikolai Novosjolov (EST, dos veces campeón del mundo) y Ana María Popescu (ROU, medalla de plata olímpica, Pekín 2008). El campamento ofrecerá un curso diverso de técnicas y prácticas de entrenamiento de espada, así como valoraciones individuales y grupales y apoyo de los campeones de espada.  Además de las actividades de esgrima, Bansko es una zona muy rica culturalmente, situada al pie del Parque Nacional de Pirin, declarado Patrimonio de la Humanidad por la UNESCO. Esta moderna región ofrece una amplia variedad de opciones para explorar la naturaleza y la historia, así como las atracciones recreativas. Bansko está a unas dos horas en coche al sur de Sofía. Organizado por la Academia de Esgrima MK y el Club de Esgrima de Sofía, el evento también está asociado con la Federación Búlgara de Esgrima. La inscripción anticipada (con descuento) está disponible hasta el 31 de marzo. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>Este verano se celebrar\xE1 un campamento de espada en Bansko, Bulgaria, del 29 de julio al 5 de agosto, que ofrecer\xE1 a los j\xF3venes atletas de todo el mundo la oportunidad de trabajar directamente con medallistas de los Juegos Ol\xEDmpicos y del Campeonato del Mundo.</b></p>\n      <p>El Campamento Internacional de Esgrima est\xE1 abierto a esgrimistas principiantes, de nivel intermedio y de \xE9lite, ni\xF1os y ni\xF1as, de las categor\xEDas sub-12 (2010-2007), sub-15 (2006-2004) y sub-18 (2003-2001). En el campamento con una duraci\xF3n de seis d\xEDas participar\xE1n Rub\xE9n Limardo-Gasc\xF3n (VEN, medalla de oro ol\xEDmpica, Londres 2012), Nikolai Novosjolov (EST, dos veces campe\xF3n del mundo) y Ana Mar\xEDa Popescu (ROU, medalla de plata ol\xEDmpica, Pek\xEDn 2008). El campamento ofrecer\xE1 un curso diverso de t\xE9cnicas y pr\xE1cticas de entrenamiento de espada, as\xED como valoraciones individuales y grupales y apoyo de los campeones de espada.</p>\n      <p>Adem\xE1s de las actividades de esgrima, Bansko es una zona muy rica culturalmente, situada al pie del Parque Nacional de Pirin, declarado Patrimonio de la Humanidad por la UNESCO. Esta moderna regi\xF3n ofrece una amplia variedad de opciones para explorar la naturaleza y la historia, as\xED como las atracciones recreativas. Bansko est\xE1 a unas dos horas en coche al sur de Sof\xEDa.\n      Organizado por la Academia de Esgrima MK y el Club de Esgrima de Sof\xEDa, el evento tambi\xE9n est\xE1 asociado con la Federaci\xF3n B\xFAlgara de Esgrima. La inscripci\xF3n anticipada (con descuento) est\xE1 disponible hasta el 31 de marzo.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/109/es/static/_mobile/54.png\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 55-title\" style=\"top:89px;left:85px\" src=\"/109/es/static/_content/55-title.png\">\n\n      <img class=\"halfScale 55-line\" style=\"top:267px;left:848px\" src=\"/109/es/static/_content/55-line.png\">\n\n      <img class=\"halfScale 55-sub\" style=\"top:267px;left:884px\" src=\"/109/es/static/_content/55-sub.png\">\n\n      <img class=\"halfScale pointer 55-arrow\" style=\"top:845px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/55-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg55Anim = new TimelineMax()\n            pg55Anim\n              .fromTo(cOf(\"55-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n              .fromTo(cOf(\"55-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n              .fromTo(cOf(\"55-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n              .fromTo(cOf(\"55-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg55Anim.stop()\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  EL PROYECTO DE ESGRIMA DE ECUADOR AYUDA A LOS NIÑOS QUITO, ECUADOR DESFAVORECIDOS 31 DE ENERO DE 2019",
    "mobileHtml": "\n      <h2>EL PROYECTO DE ESGRIMA DE ECUADOR AYUDA A LOS NI\xD1OS DESFAVORECIDOS</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg55-ecuador.jpg\">\n      <p><b>QUITO, ECUADOR<br>31 DE ENERO DE 2019<br></b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 56-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/109/es/static/_content/53-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/109/es/static/_content/53-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/109/es/static/_content/53-social-fb.png\">\n      </a>\n\n      <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg56Anim = new TimelineMax()\n          pg56Anim\n            .fromTo(cOf(\"56-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete:addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg56Anim.stop();\n          removeContentLinks()\n        }\n      ",
    "searchText": "FIE & NATIONAL FEDERATION NEWS 2 OF 2  “NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  «Cuesta encontrar clases de esgrima a las que asistan 50 participantes en Quito, pero aquí hemos alcanzado esa cifra», explicó Diego Portilla, campeón nacional de sable en varias ocasiones y responsable del proyecto presentado por la EFF, en el marco del programa «DONATE YOUR FENCING GEAR» 2018 de la FIE, implementado en colaboración con el Ayuntamiento de Quito. Los niños más desfavorecidos reciben clases de esgrima gracias a la contribución de los donantes de «DONATE YOUR FENCING GEAR». «Acogemos a más de 250 niños, pero de momento solo tenemos material para unos 50», dijo Portilla. «Esperamos aumentar la cuota fija de participantes en un futuro próximo, así como la frecuencia de las clases, que hasta ahora ha estado limitada a una por semana». Los niños entrenan con los equipos provinciales y nacionales, de modo que la Federación Nacional en su conjunto (entrenadores de atletas, árbitros y directivos) se involucra activamente en el proyecto.  «Con la esgrima podemos enseñar a los niños muchas cosas», explicó Portilla, que también es una hábil psicólogo especializado en terapia sistémica. «Lo primero que aprenden es autocontrol, porque en la esgrima, si no te controlas, pierdes. También aprenden a respetar al oponente». «Los entrenadores involucrados en el proyecto son todos entrenadores nacionales o árbitros que también trabajan en clubes de esgrima locales», concluyó Lorena Arroyo, Presidenta de la Federación Ecuatoriana de Esgrima, al final de la visita. «La esperanza es que de este grupo surjan jóvenes talentos que sigan con su carrera deportiva en uno de los clubes en caso de que deseen incorporarse. No descartamos que un día lleguen a ser seleccionados para la selección nacional». ■ W W W.FIE .ORG",
    "mobileHtml": "\n      <p><b>\xABCuesta encontrar clases de esgrima a las que asistan 50 participantes en Quito, pero aqu\xED hemos alcanzado esa cifra\xBB, explic\xF3 Diego Portilla, campe\xF3n nacional de sable en varias ocasiones y responsable del proyecto presentado por la EFF, en el marco del programa \xABDONATE YOUR FENCING GEAR\xBB 2018 de la FIE, implementado en colaboraci\xF3n con el Ayuntamiento de Quito.</b></p>\n      <p>Los ni\xF1os m\xE1s desfavorecidos reciben clases de esgrima gracias a la contribuci\xF3n de los donantes de \xABDONATE YOUR FENCING GEAR\xBB.</p>\n      <p>\xABAcogemos a m\xE1s de 250 ni\xF1os, pero de momento solo tenemos material para unos 50\xBB, dijo Portilla. \xABEsperamos aumentar la cuota fija de participantes en un futuro pr\xF3ximo, as\xED como la frecuencia de las clases, que hasta ahora ha estado limitada a una por semana\xBB. Los ni\xF1os entrenan con los equipos provinciales y nacionales, de modo que la Federaci\xF3n Nacional en su conjunto (entrenadores de atletas, \xE1rbitros y directivos) se involucra activamente en el proyecto.</p>\n      <p>\xABCon la esgrima podemos ense\xF1ar a los ni\xF1os muchas cosas\xBB, explic\xF3 Portilla, que tambi\xE9n es una h\xE1bil psic\xF3logo especializado en terapia sist\xE9mica. \xABLo primero que aprenden es autocontrol, porque en la esgrima, si no te controlas, pierdes. Tambi\xE9n aprenden a respetar al oponente\xBB.</p>\n      <p>\xABLos entrenadores involucrados en el proyecto son todos entrenadores nacionales o \xE1rbitros que tambi\xE9n trabajan en clubes de esgrima locales\xBB, concluy\xF3 Lorena Arroyo, presidenta de la Federaci\xF3n Ecuatoriana de Esgrima, al final de la visita. \xABLa esperanza es que de este grupo surjan j\xF3venes talentos que sigan con su carrera deportiva en uno de los clubes en caso de que deseen incorporarse. No descartamos que un d\xEDa lleguen a ser seleccionados para la selecci\xF3n nacional\xBB.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"bottom:56px;right:625px;width:290px; height:47px;\">\n          <a href=\"http://www.pbtfencing.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:56px;right:65px;width:331px; height:47px;\">\n          <a href=\"http://www.instagram.com/pbt_fencing/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"bottom:56px;right:1185px;width:290px; height:47px;\">\n          <a href=\"mailto:sales@pbtfencing.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <a href=\"http://www.pbtfencing.com\" target=\"_blank\">\n          <img src=\"/109/es/static/_mobile/57.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/109/es/static/_mobile/58.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n        <img id=\"59-title\" class=\"halfScale\" style=\"top:132px;left:83px\" src=\"/109/es/static/_content/59-title.png\">\n        <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <img id=\"59-logo\" class=\"halfScale\" style=\"top:106px;left:1271px\" src=\"/109/es/static/_content/59-logo.png\">\n        </a>\n        <img id=\"59-next\" class=\"halfScale pointer\" style=\"top:938px;left:1174px\" src=\"/109/es/static/_content/59-arrow.png\">\n\n        <a href=\"http://fie.org/es?no-redirect=\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <div class=\"addContentLink\" style=\"top: 433px; left: 134px; width: 230px; height: 34px;\" onclick=\"showOverlay('59-pop-1')\"></div>\n        <div id=\"59-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/109/es/static/_content/59-pop-1.jpg\">\n          <div class=\"addContentLink\" style=\"top: 63px; left: 1339px; width: 135px; height: 49px;opacity:0\" onclick=\"hideOverlay('59-pop-1');\"></div>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top: 662px; left: 1042px; width: 147px; height: 62px;\" onclick=\"showOverlay('59-pop-2')\"></div>\n        <div id=\"59-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/109/es/static/_content/59-pop-2.jpg\">\n          <div class=\"addContentLink\" style=\"top: 51px; left: 1320px; width: 172px; height: 49px;opacity:0\" onclick=\"hideOverlay('59-pop-2');\"></div>\n        </div>\n        ",
    "script": "\n        function onPageEnter() {\n          pg59Anim = new TimelineMax()\n          pg59Anim.fromTo(idOf(\"59-title\"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)\n            .fromTo(idOf(\"59-logo\"), 0.3,{opacity:0}, {opacity:1},\"-=0.2\")\n            .fromTo(idOf(\"59-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, \"-=0.2\")\n        } \n\n        function onPageLeave() {\n          pg59Anim.stop();\n          removeContentLinks();\n          hideOverlay('59-pop-1');\n          hideOverlay('59-pop-2');\n        }\n      ",
    "searchText": "NOTICIAS  NOTICIAS DE LA FIE 1   Se anuncia la Prueba test de esgrima olímpica Ver más aquí.  WWW.FIE.ORG  2  Peter Jacobs recibe el Premio de Honor del Imperio Británico Ver más aquí.  W W W.FIE .ORG",
    "mobileHtml": "\n      <h2>NOTICIAS DE LA FIE</h2>\n      <img id=\"fwdimg\" src=\"/109/es/static/_mobile/pg59-news.jpg\">\n      <p><b>PETER JACOBS AWARDED BRITISH EMPIRE HONOUR</b></p>\n      <p>Peter Jacobs recibe el Premio de Honor del Imperio Brit\xE1nico\n      Ver m\xE1s aqu\xED.</p>\n      <p>El anuncio forma parte de la programaci\xF3n general de las Pruebas test \xABReady Steady Tokyo\xBB, que incluye pruebas de ensayo general con la intenci\xF3n de garantizar el \xE9xito durante los Juegos Ol\xEDmpicos. Est\xE1n organizados por federaciones internacionales y nacionales (FI/FN), as\xED como por el Comit\xE9 Organizador de Tokio 2020. De las cincuenta y seis pruebas test, algunas se celebrar\xE1n durante las pruebas deportivas de FI/FN, y otras 22 se organizar\xE1n antes de Tokio 2020.</p>\n      <p>La prueba test de esgrima tendr\xE1 lugar del 13 al 15 de diciembre de 2019 en el marco de la Copa del mundo de Florete y del Trofeo Pr\xEDncipe Takamado de la FIE. Tendr\xE1 lugar en el Makuhari Messe (Sala B), uno de los centros de convenciones m\xE1s grandes de Jap\xF3n, situado en la ciudad de Chiba, Prefectura de Chiba. En varias salas se celebrar\xE1n esgrima, taekwondo y lucha libre durante los Juegos Ol\xEDmpicos de Tokio 2020.</p>\n      "
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": [{
    "title": "Escrime XXI N⁰. 109",
    "cssClass": "cover mobile-p1",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 0,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 2,
      "subIndex": 0
    }]
  }, {
    "title": "Comité Ejecutivo de la FIE",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 4,
      "subIndex": 0
    }]
  }, {
    "title": "Prólogo",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 5,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 6,
      "subIndex": 0
    }]
  }, {
    "title": "Doha",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 7,
      "subIndex": 0
    }, {
      "index": 8,
      "subIndex": 0
    }, {
      "index": 9,
      "subIndex": 0
    }]
  }, {
    "title": "Turín",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 10,
      "subIndex": 0
    }, {
      "index": 11,
      "subIndex": 0
    }, {
      "index": 12,
      "subIndex": 0
    }]
  }, {
    "title": "El Cairo",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 13,
      "subIndex": 0
    }, {
      "index": 14,
      "subIndex": 0
    }, {
      "index": 15,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 16,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 17,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 18,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Heidenheim",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 19,
      "subIndex": 0
    }, {
      "index": 20,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - París",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 21,
      "subIndex": 0
    }, {
      "index": 22,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Katowice",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 23,
      "subIndex": 0
    }, {
      "index": 24,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - La Habana",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 25,
      "subIndex": 0
    }, {
      "index": 26,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Saint Maur",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 27,
      "subIndex": 0
    }, {
      "index": 28,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 29,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 30,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Tokio",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 31,
      "subIndex": 0
    }, {
      "index": 32,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Salt Lake City",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 33,
      "subIndex": 0
    }, {
      "index": 34,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Varsovia",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 35,
      "subIndex": 0
    }, {
      "index": 36,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Vancouver, B.C.",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 37,
      "subIndex": 0
    }, {
      "index": 38,
      "subIndex": 0
    }]
  }, {
    "title": "Copa del Mundo - Barcelona",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 39,
      "subIndex": 0
    }, {
      "index": 40,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 41,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 42,
      "subIndex": 0
    }]
  }, {
    "title": "Vista Previa",
    "cssClass": "purple",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 43,
      "subIndex": 0
    }, {
      "index": 44,
      "subIndex": 0
    }, {
      "index": 45,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 46,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 47,
      "subIndex": 0
    }]
  }, {
    "title": "Conozca a los Atletas - Yuka Ueno",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 48,
      "subIndex": 0
    }, {
      "index": 49,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 50,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias de la FIE y de las Federaciónes Nacionales",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 51,
      "subIndex": 0
    }, {
      "index": 52,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 53,
      "subIndex": 0
    }]
  }, {
    "title": "El Proyecto de Esgrima",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 54,
      "subIndex": 0
    }, {
      "index": 55,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 56,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 57,
      "subIndex": 0
    }]
  }, {
    "title": "Noticias",
    "cssClass": "yellow",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 58,
      "subIndex": 0
    }]
  }],
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length - 1) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-137252729-4',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pqpo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TKcf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UhHM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UrMh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UxE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vtxw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aKuC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kZKJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kxw3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXGk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vvnJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.afad71cb4b438fc90557.js